module.exports = {
  "+1Wujb": "{num}條",
  "+4lD9e": "姓名",
  "+L9lak": "套用警報模板",
  "+bRanp": "請填寫通知上限次數",
  "+d7aNN": "警報模板清單",
  "/COTHZ": "警報模組名稱不能為空",
  "/cqdKk": "下載",
  "/l9tS2": "未觸發",
  "/sI6h+": "人",
  "z9+Z7p": "跨標籤",
  "03eM6t": "200條/頁",
  "0JCY6+": "部署人",
  "0sn8j/": "請填入姓名",
  "1UXyeT": "觸發時間",
  "1WymPU": "選擇警報觸發值",
  "2+X2n8": "批次刪除",
  "28oE7E": "未選擇任何裝置",
  "29A4OA": "公司成員",
  "2QzYmY": "取消",
  "2rDc7R": "警報規則不能為空",
  "2t0Cct": "部署日期",
  "32AbcK": "選擇公司",
  "36+mbi": "處理狀態",
  "3HzQUc": "導出JSON",
  "3RVwfq": "請填寫註解",
  "3aYG4L": "移除裝置目前所套用的警報模板，不再監控與發送警報",
  "3qVnoZ": "設備數（{num}）",
  "4/e9qs": "請填入名稱",
  "4VVrWd":
    "是否確認禁用（{name}）該警報模板？禁用後新增警報設備將無法套用該模版。",
  "4vWL+W": "導入設備",
  "4wi+/p": "範本",
  "5SSVAQ": "新增警報範本",
  "5grmob": "請填寫信箱",
  "5p8cBO": "帳號管理",
  "60Ixlm": "警報範本名稱",
  "6ABIlp": "觸發狀態",
  "6mjOF/": "批次重置",
  "7G1c4h": "設備清單",
  "8PESa6": "禁用",
  "919TK9": "支援格式：xls、xlsx",
  "9Kfib+": "未知錯誤",
  "9UefLp": "標籤",
  B57Wbu: "未選擇設備",
  BC74I9: "提示訊息",
  BQcLxf: "下移",
  BYbqwY: "將檔案拖曳到此處 或點選上傳",
  BhkglP: "查看token",
  BwXapw: "分類名稱請控制在500字元內",
  CLqPBU: "編輯",
  D3lDHK: "新增警報規則",
  D5HOUz: "選擇狀態",
  E2kRYi: "批量啟用",
  "EZ+vMa": "模板註解",
  EwM8Kj: "確定要移出嗎？",
  Ey9rBq: "確定要刪除嗎？",
  F2LJDJ: "確定要移除嗎？",
  F56ZKt: "選擇成員",
  FEb7U2: "確認",
  "FaJ/jI": "沒有選擇要匯入的檔案",
  FbCeo1: "觸發值",
  FbsCUK: "手機",
  FeJVkL: "新增例外物件",
  "Fr1I/b": "貼標籤",
  "G+BH4o": "是否確認刪除（{name}）目前設備？",
  GKSW97: "批次停用",
  GQ5EVQ: "請至少勾選一個",
  GUMdjP: "最後執行狀態",
  Gk0Mt5: "是否確認重設（{name}）此警報設備？重設後警報規則將繼續執行監控。",
  GujK99: "若後續警報範本的內容有更新，也會同步給套用的裝置",
  HN1dNJ: "所有帳號",
  IqkgWZ: "關鍵字",
  "Iwt/8W": "註解",
  "J0D5h+": "開始時間",
  J9jPRL: "複製成功",
  JJl2M9: "導出",
  JeJAmT: "重新命名",
  Jh62y5: "所有設備",
  Jp7u8z: "台",
  LWSLHa: "溫馨提示",
  Ls1X2Z: "已處理",
  "LuP+H0": "描述",
  LwhdsE: "切換多重選擇",
  MnTdIi: "觸發次數",
  MvGPdx:
    "是否確認啟用（{name}）此警報範本？啟用後新增警報設備可以套用此模版。",
  N4np50: "通知上限次數",
  NTanl8: "新增警報模板",
  NW8FV4: "設備指令狀態",
  OsMncl: "未開啟",
  "P/eul9": "否",
  P6YSaZ: "警報歷史記錄",
  PgNsL5: "部署中",
  "Py/5UG": "操作的節點已不存在，請重新操作",
  "Q2/NzC": "已選擇{num}台設備",
  QHhMxE: "選擇角色",
  QV3pnn: "狀態",
  "QavrS/": "規則名稱",
  QwHI8Q: "查詢結果：",
  R2D5Dv: "建立時間",
  R3TTCW: "編輯警報模板",
  S57QRB: "Filter by",
  SGDlQ6: "共{total}條",
  T3CtvK: "分類名稱不能為空",
  TDuPUp: "已觸發",
  TqDOFU: "請勿經常發送驗證碼！",
  U2DqqT: "搜尋公司",
  UBbWUL: "未選擇任何範本",
  UFjZVV: "部署狀態",
  UUtqvk: "未處理",
  UcumBq: "警報通知",
  UtE0dS: "操作",
  "Uu/nFu": "移除所有本設備套用的警報模版",
  V0RiZp: "操作成功",
  VR6zMp: "確定要停用嗎？",
  VRizgn: "請填寫手機號碼",
  ViVQNi: "角色",
  WeKYMe: "最後指令時間",
  Wp6QLH: "是否確認重設（{name}）該警報規則？重設後警報規則將繼續執行監控。",
  "WwRq+y": "請新增警報通知對象",
  "X/cNgA": "刪除提醒",
  XFEq9J: "模板狀態",
  XG2wHz: "部署成功",
  XMBOec: "移除標籤",
  XeiAal: "刪除",
  XgmTAk: "裝置SN",
  YBAsWB: "設備指令",
  YpXN8m: "最後觸發時間",
  ZETl7o: "警報模板",
  ZMUuo8: "確定要啟用嗎？",
  ZPSpaL: "警報模組名稱",
  ZUPzqr: "開啟",
  "Zvt+2g": "倉儲",
  aBleoN: "選擇警報模板",
  "aN+DgN": "啟動時間",
  aiBGBs: "刪除成功",
  i5Nyva: "未讀",
  ich0wH: "裝置SN",
  wpKIvP: "已讀",
  "arp+TQ": "50條/頁",
  "bE+h3K": "設備狀態",
  bOKDVF: "切換單選",
  bqbDVw: "查詢",
  cDZ00w: "檢視",
  drCsUI: "公司",
  e8OyHO: "20條/頁",
  f7Dpbl: "下載範本，根據範本提示完善內容",
  fz2pkM: "該節點已刪除",
  gU4eZD: "警報管理",
  ggvI6Z: "全選",
  gomg5W: "停用提醒",
  gzHM5l: "警報發布日期",
  "hDx3/S": "信箱",
  hMboy7: "指令狀態詳情",
  iKomBu: "暫無分類",
  ieTzi7: "警報模板詳情",
  ifGp4v: "2FA",
  iyOrrD: "100條/頁",
  j6IHvr: "查看詳情",
  jT6zKT: "設備數",
  jdbKm7: "警報通知對象",
  jddlWH: "部署失敗",
  kCh5Jz: "提示",
  kG2Etz: "線上",
  khyRcw: "請選擇Excel檔案",
  kwOS33: "啟用提醒",
  l1fZNE: "不可全部取消勾選",
  loTFGc: "未命名",
  m0Qdyj: "驗證失敗",
  ma6S6y: "自訂顯示",
  "mpeFt+": "警報規則",
  nH1F3p: "是否確認刪除（{name}）目前警報規則？",
  nJCPaY: "使用者沒有綁定信箱，無法進行驗證",
  nUSeQB: "未選擇帳號",
  nw8orn: "通知人數",
  pBPyFt: "Nubis版本",
  "pV2t/S": "基本資訊",
  pcU9bM: "新增成員",
  q6qKtH: "查詢條件：",
  qUKj7E: "複製",
  "r0/TUu": "確定",
  "r2dEd/": "重置",
  s9U9qn: "設定警報",
  sOIerB: "未啟動",
  sZSyGZ: "啟用",
  srEpKw: "正在上傳",
  srpWCM: "勾選需要顯示的欄位，可拖曳進行排序",
  t2iHNJ: "更新",
  "tCh+iz": "警報發佈時間",
  tLW3W3: "手機號碼",
  tokMPz: "例外物件",
  "uoZwj+": "創建人",
  v04auv: "結束時間",
  w8L9Kj: "配置警報規則",
  wOHHSJ: "上移",
  wQAiLI: "重置提醒",
  xISm1t: "啟動",
  xUjLTE: "搜尋",
  y9NWzQ: "警報設備列表",
  yGWx2z: "參數錯誤",
  yOMNOj: "是",
  yReEcE: "選擇標籤",
  yXsHgv: "10條/頁",
  yb3AuG: "離線",
  ybGQQ3: "無相關結果",
  "yiO/gL": "範本清單",
  yxPDHk: "發佈狀態",
  zH7h1q: "歷史記錄",
  "96Mzoq": "已完成",
  ByhhM1: "條件",
  PcCooF: "警報觸發值",
  RUMaeu: "請將警報規則填入完整",
  h7w4pz: "暫無資料",
  nMMNa6: "我們會透過電子郵件、簡訊或系統通知您。",
  "nOE0/j": "搜尋公司、會員",
  q6WPYA: "選擇裝置中包含{num}台Nubis Free版本，將無法進行群發指令。",
  "+CP3nr": "選擇任務",
  "+gbx50": "警報條件",
  "+wet4N": "驗證碼錯誤",
  "/BzHXM": "選擇創建人",
  "/SqqyP": "輸入裝置SN",
  "0YYUNG": "已選擇{num}個標籤",
  "1M03Dq": "排程模板",
  "1SslIM": "關閉應用程式",
  "1gjtU2": "最後執行時間",
  "1sj5Sj": "移除所有本設備套用的排程模版",
  "2MYr1m": "登入",
  "2l+gFk": "是否確認啟用（{name}）該排程範本？啟用後裝置可以引用該範本。",
  "2opnVU": "執行期間",
  "2r/XUW": "移除所有本標籤套用的排程模版",
  "3xlnbE": "命令時間",
  "47GdDb": "關閉",
  "5ytYaf": "新增排程範本",
  "65DvZ1": "輸入上限：4",
  "6x6nu5": "實際執行時間",
  "8zN+hZ": "執行應用程式",
  "9UZxwP": "請輸入驗證碼",
  "9kkcTB": "刪除排程範本",
  "9ljNkr": "重新發送",
  "A/eXwT": "移除所有本標籤套用的警報模版",
  AyWMlZ: "新增排程任務",
  BiPxfI: "新增排程範本",
  C6cGK1: "排程模板名稱不能為空",
  EGvInA: "設備警報列表",
  Ft60hS: "Nubis設備",
  Gwj7xc: "恢復預設",
  H15ECl: "輸入應用程式",
  "J3BW/8": "請輸入您email收到的驗證碼",
  KW8qOm: "選擇模板",
  LADN1a: "排程執行情形",
  Lfia0v: "設定排程",
  NDmD8V: "是否確認刪除（{name}）該排程範本？",
  OVecAI: "成功",
  OwtOn5: "總狀態",
  PTc6Gt: "啟用排程",
  PaMvre: "警報規則清單",
  PnYplH: "設備",
  RNaGVr: "任務失敗清單",
  RWBRyt: "設備分佈地圖建置中",
  "RuFFf/": "是否確認停用（{name}）該排程範本？停用後裝置無法引用該範本。",
  SPyEF8: "選擇模式",
  SwMBFl: "套用排程模板",
  TDSTTj: "選擇排程模板",
  UMU42c: "選擇設備",
  Unvxiq: "切換帳號",
  WxPZOH: "執行{num}次",
  WypzMq: "排程任務",
  X2m4ec: "停用排程模板",
  "YIgP+p": "設備排程清單",
  LNGTru: "設備排程失敗清單",
  YwEzx2: "勾選需要顯示的欄位",
  Z2B362: "持續",
  ZBDct6: "失敗：{num}",
  ZHAjhZ: "輸入上限：30",
  Zr9Dss: "失敗",
  azDNha: "發送成功",
  b5l2vN: "保存",
  b6y8Ai: "是否確認已停用（{name}）該排程？",
  bYIKFB: "進行中：{num}",
  "e/6XZC": "沒有收到驗證碼？",
  eAgY2G: "展開子公司",
  fl7J8Y: "訊息",
  "gH+Az7": "停用排程",
  gi4oTZ: "排程模板清單",
  gplM71: "每日",
  "hAd+eG": "設備排程日曆",
  "hD7/Lu": "顯示",
  hYN7oM: "隱藏",
  hfn1Ux: "成功/總數",
  hkJXyi: "設定排程任務",
  "hkR3E+": "檢視模式",
  hwlmeB: "目標型別",
  iN7Lps: "循環模式",
  iscUWH: "完成：{num}",
  "j/YGZ0": "地圖",
  j6Hm96: "排程執行",
  jNxbTC: "驗證碼不能為空",
  js3tZs: "排程範本名稱",
  k9dozc: "執行時間",
  kUagYW: "排程執行歷史記錄",
  l7IiCY: "排程狀態",
  "lzP/we": "ORA下載",
  m1h20o: "若後續排程模板的內容有更新，也會同步給套用的裝置",
  "mC2//O": "檢視排程日曆",
  mFIXSq: "裝置SN",
  pGioLb: "設備順序SN",
  "wnPTP+": "輸入設備SN",
  mISQTh: "詳細內容",
  nGubXb: "排程模板詳情",
  nqPJwo: "針對標籤",
  oCogiy: "指令",
  oY0m24: "使用者",
  oirnwv: "啟用排程模板",
  ojz0Ke: "看更多 >",
  oru5FY: "編輯排程範本",
  wDqNy1: "範例",
  "p+zOzc": "結果",
  peNVzr: "每{num}週",
  pfGGi0: "移除裝置目前所套用的排程模板，不再執行",
  pielKO: "開機設備",
  pkYJKs: "執行狀態",
  qhC4wy: "搜尋設備",
  rUHCoM: "裝置排程",
  sb1vdX: "進行中",
  u3dVQz: "每週",
  "5EJNIu": "跨公司搜設備",
  "urr92/": "選擇部署人",
  vovKL8: "應用路徑不能為空",
  "wrU/Kc": "每{num}天",
  ygAHaf: "發送時間",
  zvaxmN: "排程管理",
  "2ffDGT": "是否確認關閉排程任務？關閉後設備將不執行該排程範本。",
  "D//rZg": "是否確認刪除排程範本的套用？",
  E1GPl7: "擁有者",
  EwTMGn: "是否確認啟用（{name}）該排程？",
  GpzsBd: "開啟排程任務",
  IM8kXz: "是否確認刪除（{name}）的套用？",
  KXqGQe: "批次開啟",
  NGe0Cs: "刪除排程執行記錄",
  SkK50H: "請新增排程任務",
  Trt6ju: "是否確認開啟排程任務？開啟後設備需執行該排程任務。",
  UiVtQS: "批次關閉",
  "Z56D+X": "關閉排程任務",
  aKxrop: "刪除排程模板的套用",
  miANEg: "是否確認關閉（{name}）該排程任務？關閉後裝置將不執行該排程任務。",
  ngLF8L: "是否確認將（{name}）的排程執行記錄刪除？",
  nqPOJc: "是否確認開啟（{name}）該排程任務？開啟後設備需執行該排程任務。",
  oV0gpL: "排程發布日期",
  xtHJEE: "未選擇任何記錄",
  yifWnc: "是否確認將排程執行記錄刪除？",
  "+/R6RX": "任務狀態",
  "35v5wD": "是否確認重置警報歷史？",
  "3QXG/d": "Ora版本",
  "5jpkHg": "線上狀態",
  G4XFn6: "硬體型號",
  Ko5CPO: "是否確認重置該警報歷史？",
  ajVpLe: "是否確認刪除該警報歷史？",
  dEXfrL: "設備健康狀態區間",
  eCCa0L: "任務類型",
  fr4nkj: "是否確認刪除警報歷史？",
  nzsNwZ: "設備健康狀態",
  qDba8m: "離線設備狀態",
  rDRAr0: "作業系統版本",
  YeF1dY: "時區",
  BC52ne: "已忽略",
  SbZhau: "開機任務需要指定一個開機設備",
  "lsLYU/": "通知上限次數不能超過10",
  "NM/lRq": "取消上傳",
  "3qF993": "您不能轉移不在目前公司的設備。",
  "6+iYA0": "序號",
  yc6ZUL: "Ora最後更新狀態",
  UA7mv6: "Ora最後更新時間",
  "fOwU1/": "歸屬",
  jNiwk6: "是否確認刪除（{name}）該警報設備？",
  "lLa/D3": "套用型別",
  "wk1c/l": "依公司的設備可灰階更新時間",
  "5+oaTO": "image最後更新狀態",
  "6pDRb2": "請輸入有效的密碼",
  ANeFu6: "驗證密碼",
  GnzEo7: "image最後更新時間",
  s7NSze: "確認操作前請先輸入您的帳號密碼",
  "9RNrDU": "是否為代理設備",
  "+TzicH": "門店",
  "/CxA3j": "新增子門店",
  "4c3uw8": "移出門店",
  "5Hy0Qx": "不可轉移到同一門店",
  BBpRbn: "移除所有本門店套用的警報模版",
  DADacD: "移除所有本門店套用的排程模版",
  G9WbnV: "針對門店",
  S1QSWC: "匯入子門店",
  TYAJpp: "已選擇{num}個門店",
  Ve9Ksw: "轉移門店",
  Wzv7kF: "請選擇一家門店",
  h7Yvwt: "跨門店",
  jAAXdQ: "設備門店",
  "kr+7Iy": "搜尋門店",
  tFr3tb:
    "是否確認刪除（{name}）該警報模板？刪除後將同步取消設備，門店及標籤對本模板的應用。",
  uuRzdk: "歸屬門店",
  vD5wnY: "勾選要歸屬的門店，代表擁有該門店的權限",
  zyMKgy: "選擇門店",
  RndUeh: "預計執行時間",
  gcHeN9:
    "請填寫OS應用程式名稱. 例如:Windows:chrome或Android:com.android.chrome",
  EM8lAi: "依公司的設備可更新時段(本地時間)",
  "4Regzm": "門市清單",
  "1PtjRr": "裝置名稱",
  BqUpjt: "請填寫包名，例如 com.android.chrome",
  NrEurQ: "上傳 Mbps",
  Nrx60r: "下載 Mbps",
  Vd3wZV: "整體",
  WdyIyo: "運作時長",
  "XLdI1+": "Wi-Fi強度",
  cawvIS: "最後更新時間",
  "oFt+cN": "網路測速",
  tWcCoB: "測速日期",
  xrQzKh: "請填入應用程式名稱，例如 chrome",
  zok1hp: "C槽",
  i5MLJc: "最後更新時間：{lastUpdate}",
  bMdSkq: "網路測速記錄",
  "devicesList@1": "選擇全部設備",
  "devicesList@2": "選擇全部設備",
  "gyh+d1": "有線網路",
  "p/3Nn5": "行動網路",
  "i6kDf/": "選擇裝置中包含{num}台Nubis Free版本，將無法進行裝置指令。",
  o8tJYm: "設備指令",
  "+74JfZ": "範例：Device_000001_高橋店_Android",
  "+CLSks": "2. 此命名規則要套用的裝置系統類型",
  "+GQdfc": "更新Token",
  "+m8vFq": "命名規則詳情",
  "0KH9Qi": "設備系統類型",
  "0Z908D": "同一個應用程式只能選擇一個版本",
  "0bBO2n": "版本",
  "0iTEVO": "查看Token",
  "12LEcf": "是否確認停用（{name}）該命名規則？",
  "2/LdaO": "門市配置資訊",
  "2V19bd": "設定檔詳情",
  "2jlHQB": "2. 公司預設命名規則",
  "3ZtPM3":
    "若門市沒有設定命名規則，新增設備時將會套用公司的命名規則。若您不想套用，可將下列規則停用",
  "3qgucc": "手動設定時區",
  "5FboZ/": "類型",
  "5ZgUEM": "編輯設定範本",
  "5d3yZi": "生效時間",
  "5noX9X": "設定檔名稱",
  "6Ty5/G": "發佈成功",
  "7NmXNy": "目前程式資訊",
  "7PkBL6": "啟用靜默更新",
  "7ip592": "1. 命名規則名稱",
  "88CuCZ": "3. 為註冊在此門市的設備建立命名方式（自動填入設備名稱）",
  "8WYGi+": "確定要複製嗎？",
  "8huAxo": "新增規則",
  "8pB1C7": "新增應用程式",
  "8u3CYe": "命名規則名稱",
  "8zQ4So": "程式包ID：",
  "96c3gX": "格式",
  "9iKk2b": "起始號碼",
  AFZDo7: "安裝歷史",
  B0WqD0: "1. 裝置可更新時段（當地時間）",
  "CM76+/": "是否確認啟用（{name}）該範本？啟用後設備可以引用該模版",
  CPTAAj: "自然數遞增",
  CqlH6G: "套用門市清單",
  "D/Yid+": "是否啟用",
  D2KnIQ: "關聯門市成功",
  DpnauN: "時間",
  Fi4xFb: "上傳Android應用程式成功",
  G9APSK: "編輯命名規則",
  GRfLaO: "應用程式名稱",
  HDYjnT:
    "目前選取的應用程式版本低於已存在的應用，可能會造成應用程式安裝失敗，請確認應用程式是否選擇正確，如需安裝較低版本的應用，可勾選刪除原程式後再安裝。",
  HOHQFs: "命名規則名稱不能為空",
  "HdxQ2/": "門市關聯的設定檔與命名規則",
  "I/k8FH": "發佈",
  IyhhzI: "建立設定檔",
  Kj5TRg: "待安裝設備數",
  "L4w/Vo": "最新版本",
  MI3yI1: "正在上傳 {percentCompleted}%",
  MRe8Q9: "版本號碼：",
  OCp4OD: "檢視設定檔",
  PDFXBi: "立即發布",
  PkLYZS: "裝置命名規則",
  PlNIQ9: "系統設定",
  "Q+0CDu": "新增命名規則",
  Q5vbU5: "套件ID不一致",
  QpOtgZ: "門市名稱",
  R9TpN6: "預計安裝時間",
  RY4VVr: "上傳者",
  RyXQqJ: "上傳時間",
  UfxykZ: "原因",
  Unr58u: "更新時間",
  Uzdb6l: "裝置類型：",
  VqEr9u: "套用門市數",
  WfS4rv: "操作人：",
  XnimdQ: "Windows",
  Ym4SPE: "選擇發佈時間（設備執行時間）",
  ZWN1C0: "是否確認啟用（{name}）該命名規則？",
  ZdO12B: "套用門市",
  ZtZ7Yw: "程式名稱",
  aHlr3k: "移除",
  akvGrq: "配置規則",
  aqQg0p: "區域",
  batMBC: "是否確認刪除（{name}）該範本？",
  bsjenW: "啟用命名規則",
  cX08hK: "未選取任何資料",
  cijnrq: "已安裝設備",
  d8xSfX: "版本代碼",
  dGBGbt: "全部",
  dRYBRc: "版本號碼：{version}",
  eUNh5K: "待安裝設備",
  "ecTX+c": "程式名稱必填",
  eeCxuz: "OS類型",
  epaa3H: "新增命名規則",
  evJP5c: "命名規則",
  fX0dsH: "版本：",
  "fje/m/": "模板名稱：",
  fq3WGG: "設定檔管理",
  gQ7kPU: "Android",
  gnNjS5: "個人設備名稱",
  gyHdsW: "配置範本",
  hDmGQl: "是否校驗版本代碼",
  hqGPDw: "啟用24小時格式",
  hxy4wV: "解析中",
  i5JzAA: "狀態：",
  ie9Iom: "檢視設定範本",
  ifAmoA: "設定檔範本",
  imhWD8: "上傳設定",
  iroVTo: "公司設定",
  j2kqd8: "刪除命名規則",
  j3QWSE: "自然數遞增的起始號碼只能為正整數",
  jKzbw6: "更改設定",
  "jN5tO+": "版本代碼：{versionCode}",
  "jhfb/7": "保存成功",
  k7dy8j: "關聯設定檔",
  kH9MHe: "停用命名規則",
  kkLQie: "關聯門市",
  "ksb/lB": "是否刪除原始程式",
  l0mW6t: "最新更新時間",
  mRHwkp: "是否確認停用（{name}）該範本？停用後裝置無法引用該範本",
  "mYa6W/": "自訂文字",
  "mml+gT": "選擇應用",
  mn0ceu: "有重複的設定規則，請調整",
  n1yIyi: "安裝時間",
  nDwIwd: "已發佈",
  nLERtc: "更新Android應用程式",
  o9bMHL: "大小",
  oC6GBl: "Android應用程式",
  ovdKZi: "無法安裝設備數",
  qS0aFJ: "應用程式管理",
  qUiH5y: "配置規則不能為空",
  qjtl3b: "啟用系統更新",
  "qqwM/t": "設定檔",
  rdEPl7: "無法安裝裝置",
  rsAvN6: "程式名稱：",
  rw3uGa: "新建設定範本",
  "s+aIlP": "搜尋門市名稱",
  saeFbf: "文件",
  t8R6VW: "套件ID：{package}",
  twpxdo: "上傳Android應用程式",
  P76mDe: "同步檔案管理",
  "u/NB+Y": "套件ID",
  vDCwZ9: "上傳檔案",
  vLW90z: "是否確認刪除（{name}）該命名規則？",
  vr5TVT: "請輸入",
  wiSRo9: "安裝設備數",
  "xE1H+X": "設定",
  xdjVt1: "未填寫範本名稱",
  xlNcvg: "最近更新時間：",
  xwYDb8: "版本代碼：",
  ydktLD: "分隔符號",
  zeMk2K: "草稿",
  zrIs7T: "最近更新時間",
  "a++4i0": "發佈時間必須在24小時後",
  "3JwoQQ": "上傳失敗，該應用程式無法解析。",
  "9Fvzl9": "大量發布",
  OiP4rW: "目前已有設定檔關聯門市，請檢查。",
  b95U3r: "設定檔清單",
  nJetAr: "不支援的格式。",
  lPA1qT: "此設定只針對特定裝置",
  oXfYag: "版本代碼已存在，請重新上傳",
  "k+a7BC": "執行靜默更新時間",
  "/k2Fs5": "配置命名規則",
  e2ys3T: "門店配置詳情",
  yy7EDI: "上傳",
  "+cCXuw": "從檔案選擇圖片",
  "0cZQXI": "透過套件id新增",
  "0xm1Zu": "鎖定組合鍵",
  "33bmiC": "父目錄不存在",
  "4UcMA+": "新增Wi-Fi",
  "4ia8sI": "功能控制",
  "4o167y": "自訂文字長度不能超過30",
  "66awCH": "刷新",
  "C+cw77": "桌布配置",
  E6G3sr: "Kiosk模式",
  "FQK+2G": "檔案同步",
  FWlWJR: "查看門市資訊",
  HI1PTY: "輸入資料夾路徑",
  HNavdr: "公司名稱",
  JPIKnb: "主畫面",
  MufYuw: "鎖定畫面",
  NPjnPZ: "亮度",
  "Pdx/YD": "密碼",
  Pg5mqb: "橫向模式",
  QSjBm5: "檔案不存在",
  UH1kCc: "新增",
  UduVZX: "選擇檔案",
  Usn1oq: "縱向模式",
  "Ymq1/H": "裝置資料夾名稱",
  YzG9Iw: "黑名單",
  ZK1d6f: "SSID",
  bGGvOS: "選擇圖片",
  c8uKl6: "Wi-Fi",
  dZlNkV: "新增設定",
  dmEBpU: "檔案同步配置",
  foT1aq: "目前上傳進度：",
  g5Pknn: "檔案大小超過限制",
  gltp3e: "關閉Windows通知",
  gweUAO: "鎖定USB介面",
  nxeBGd: "範例：",
  o8HwKf: "檔名",
  rULuF3: "是否僅允許下列網路連線",
  tIm58E: "停止",
  tR69qg: "Windows顯示語言",
  tnYpSo: "偵測請求發送成功",
  xNeD5U: "已取消",
  xiwfUp: "音量",
  znna6r: "門市資訊",
  "+UT6Us": "辛巴威",
  "+cSl6d": "荷蘭",
  "+vx0UI": "所羅門群島",
  "+vz4Gy": "塞拉利昂",
  "/1g/gd": "吉里巴斯",
  "/EzG+0": "蒙特塞拉特",
  "/ZaEbq": "海地",
  "07BMT/": "阿爾及利亞",
  "0E6+/f": "關島",
  "14axoc": "福克蘭群島",
  "1BFTBO": "古巴",
  "1GLoiG": "格魯吉亞",
  "1Z3cpQ": "象牙海岸",
  "1qc1Bb": "拉脫維亞",
  "217kis": "盧旺達",
  "2c/STs": "摩爾多瓦",
  "3B2kCX": "法羅群島",
  "3Nlsp9": "斯洛伐克",
  "3a17nf": "庫克群島",
  "41lx/9": "阿富汗",
  "4KMP9f": "剛果",
  "4obEtL": "多哥",
  "5w+tOJ": "阿爾巴尼亞",
  "62Z8c1": "帛琉",
  "6JR/Y7": "愛爾蘭",
  "6LZPqX": "薩摩亞",
  "6Mnz8p": "毛里塔尼亞",
  "6NPwCy": "敘利亞",
  "6f8kym": "伊拉克",
  "6qdPnx": "突尼西亞",
  "7KZ6vz": "委內瑞拉",
  "7hGupC": "立陶宛",
  "7hNQVL": "菲律賓",
  "7p85Tc": "庫拉索",
  "8m5tda": "埃及",
  "8y7qAE": "中非共和國",
  "98qFTO": "澤西",
  "99fbLn": "烏拉圭",
  "9T1JPo": "馬耳他",
  AD5RPE: "赤道幾內亞",
  AKnToQ: "乍得",
  "AO/9GT": "芬蘭",
  AYs4yh: "馬達加斯加",
  Ai6HyC: "烏干達",
  AksTq6: "安地卡及巴布達",
  ArbweL: "約旦",
  AzRGCX: "德國",
  "B/oRh5": "密克羅尼西亞聯邦",
  BcJbbP: "卡達",
  Bm5GdP: "中國臺灣",
  MRbe2A: "中國臺灣",
  BwMY6I: "西撒哈拉",
  BxT2qw: "托克勞",
  C0YR5J: "土庫曼",
  C2pikc: "南蘇丹",
  C7RUR5: "諾魯",
  CKu8W1: "紐埃",
  CYSGlA: "愛沙尼亞",
  "D/Hl19": "馬提尼克",
  DPthJ5: "盧森堡",
  Dxf50E: "葛摩",
  EMaGPN: "索馬利亞",
  "Eihfz+": "巴基斯坦",
  Eul4yJ: "義大利",
  F0BTvX: "留尼旺",
  FsQ2Ph: "北馬里亞納群島",
  FzXhJn: "梵蒂岡",
  GRDGdf: "新喀里多尼亞",
  "HF/NiY": "亞美尼亞",
  HN9EHr: "韓國",
  HTqMY5: "羅馬尼亞",
  HZs8KL: "布吉納法索",
  I2RkrK: "柬埔寨",
  I7Erl3: "摩洛哥",
  IGBRed: "亞塞拜然",
  IPfyBg: "伊朗",
  IbG9YJ: "諾福克島",
  "IrME/4": "中國澳門",
  XeQT0P: "中國澳門",
  J1oSvz: "美屬維爾京群島",
  JIPBj1: "牙買加",
  JIWrkV: "加拿大",
  JJhl02: "剛果民主共和國",
  JOJTuh: "哥斯大黎加",
  JddSbX: "多米尼克",
  L7PjzJ: "聖誕島",
  LShUE0: "不丹",
  "Le+IiI": "北馬其頓",
  LeMbDw: "尚比亞",
  LfkgD6: "澳洲",
  Lszars: "美國",
  M16xFB: "汶萊",
  MMzrYK: "列支敦斯登",
  MTVChl: "東加",
  MXueJK: "安道爾",
  MYneOz: "吉布地",
  MZwu6r: "赫德島和麥克唐納群島",
  MbV1M9: "馬來西亞",
  MkBrsn: "巴拉圭",
  MwNlM3: "蒲隆地",
  MyB1Vf: "沙烏地阿拉伯",
  NcwUGt: "以色列",
  OZFYbQ: "瓦努阿圖",
  OZyB9b: "波士尼亞與赫塞哥維納",
  Oc4oig: "玻利維亞",
  OhEAqA: "希臘",
  Oql6Jb: "葡萄牙",
  PB00mS: "瓦利斯和富圖納",
  PBGuz3: "波蘭",
  PIBLYF: "中國香港",
  "1ObLsW": "中國香港",
  PIHPBR: "法屬聖馬丁",
  PjOc8o: "白俄羅斯",
  "Q+FGAs": "冰島",
  "Q5QY0+": "開曼群島",
  Q5U8nY: "美屬薩摩亞",
  QA9U89: "英屬印度洋領地",
  QRUdeg: "墨西哥",
  QxRaqi: "丹麥",
  RfQSLo: "北韓",
  RlB4rB: "南喬治亞島和南桑威奇群島",
  RsWzOr: "匈牙利",
  RzKiE0: "波多黎各",
  SEJjjI: "南極洲",
  SLmrMX: "保加利亞",
  T6qzNm: "寮國",
  Tb6AtC: "阿拉伯聯合大公國",
  To4yI6: "甘比亞",
  TqXGpl: "貝里斯",
  UQHsPm: "維德角",
  UZmEHG: "蒙古",
  Ulf4Sq: "印度",
  VCRq6v: "皮特凱恩群島",
  VIFtwp: "喀麥隆",
  VTEHKS: "幾內亞比紹",
  VWg1hF: "斯瓦爾巴特群島和揚馬延島",
  VhGXkw: "奧蘭群島",
  W2fcGi: "蘇利南",
  W9gKgU: "塞席爾",
  WAl9tj: "東帝汶",
  "WH+mo5": "烏茲別克",
  WJAfY4: "吐瓦魯",
  WobBPP: "賴比瑞亞",
  XfoqmV: "薩爾瓦多",
  XoOuKT: "哈薩克",
  YINkHp: "塞爾維亞",
  YMjT8q: "新加坡",
  "Z+fptr": "哥倫比亞",
  ZHe4St: "印尼",
  ZRhaI4: "巴貝多",
  ZgLO7j: "黎巴嫩",
  a9nZYf: "布威島",
  aNVBIV: "法國",
  afgUkt: "千里達及托巴哥",
  ahaefV: "中國",
  b8Yur0: "貝南",
  bCl9eg: "越南",
  bKHwtk: "孟加拉",
  bQkGVT: "俄羅斯聯邦",
  "cio5m/": "紐西蘭",
  "d+SgS7": "尼加拉瓜",
  d97FOT: "巴布亞紐幾內亞",
  dUeWgE: "斐濟群島",
  dXFo2O: "挪威",
  dcfcTW: "聖皮埃爾和密克隆",
  dyBAW0: "塞內加爾",
  eNa9WG: "聖赫勒拿",
  eX9WT0: "聖馬利諾",
  eiecNW: "賴索托",
  eu7j6G: "蒙特內哥羅",
  f6i4Ch: "多明尼加共和國",
  fSGNZz: "比利時",
  fe4fox: "蘇丹",
  fp4MWN: "日本",
  g44w8D: "聯合王國",
  gIZauu: "瓜地馬拉",
  gb8v87: "土耳其",
  h70zPD: "西班牙",
  hB6jsF: "賽普勒斯",
  hBpMeF: "馬紹爾群島",
  hC0etv: "智利",
  hLeEYi: "聖文森及格瑞那丁",
  hrmyDn: "坦尚尼亞",
  htLGF6: "博內爾",
  htNRZG: "摩納哥",
  hy4yn7: "吉爾吉斯",
  iJsE6u: "馬利",
  iVyVIA: "根西島",
  iYdC7o: "尼泊爾",
  icfTwL: "斯里蘭卡",
  icoYQF: "法屬南部領地",
  ipoOkJ: "尼日",
  j2GbDK: "聖多美普林西比",
  "j83TV+": "曼島",
  jHmcI7: "幾內亞",
  jKdq05: "阿魯巴",
  "jZLo+u": "葉門",
  kCwSgm: "瑞典",
  lAVHXj: "加彭",
  lc0eVA: "聖巴泰勒米",
  ljBSDy: "巴林",
  mIgnTu: "百慕達",
  mdbt1h: "格瑞那達",
  n1eYYR: "克羅埃西亞",
  n6sdJi: "奈及利亞",
  nU0AoJ: "模里西斯",
  nbVGOe: "蓋亞那",
  ncprFv: "巴勒斯坦",
  nfMTZ9: "阿拉伯利比亞民眾國",
  "oC/YmL": "安哥拉",
  oJA0AV: "烏克蘭",
  ofe1Jv: "斯洛維尼亞",
  ox0SUk: "厄利垂亞",
  pG9dnN: "法屬圭亞那",
  pGsPfz: "塔吉克",
  "prG89+": "荷屬聖馬丁",
  "qKL/I7": "厄瓜多",
  qhRoDt: "捷克共和國",
  r0r576: "奧地利",
  riK5Od: "馬約特",
  "s/ZbGB": "直布羅陀",
  sVaevR: "法屬玻里尼西亞",
  sgg3ZA: "肯亞",
  srKhxN: "巴哈馬",
  ssKHGM: "格陵蘭",
  swmjZg: "泰國",
  "tUisY+": "迦納",
  u3ws3s: "南非",
  u9cEKj: "聖克里斯多福及尼維斯",
  uPO36O: "緬甸",
  uY8iM9: "莫三比克",
  ufZlit: "巴拿馬",
  ufyzs9: "聖露西亞",
  v8IwQb: "阿根廷",
  vPS1uD: "秘魯",
  vTEjni: "馬拉威",
  vcSBZu: "巴西",
  vixhhG: "馬爾地夫",
  "wL/u2o": "特克斯和凱科斯群島",
  "wYCJ++": "史瓦帝尼",
  "we/YPm": "阿曼",
  xFrFSm: "納米比亞",
  xV0lln: "英屬維爾京群島",
  xepQSL: "科科斯（基林）群島",
  xk4ByO: "瓜德羅普",
  xwICWz: "瑞士",
  yC4n0v: "科威特",
  yKWAek: "安圭拉",
  yLlbwi: "波札那",
  zhs13i: "宏都拉斯",
  zw39MM: "衣索比亞",
  "+31PFz": "亞洲/烏魯木齊",
  "+6yBji": "亞洲/曼谷",
  "+CgfU2": "太平洋/埃法特",
  "+POdLR": "歐洲/伏爾加格勒",
  "+VqRkg": "美洲/肯塔基/蒙蒂塞洛",
  "/+Dhy+": "美洲/聖保羅",
  "/D9zXZ": "大西洋/雷克雅未克",
  "/UGQnF": "美洲/諾姆",
  "0DYv/B": "非洲/奈洛比",
  "0HnaGc": "太平洋/夸賈林",
  "0R8CQs": "歐洲/布達佩斯",
  "0xV9JO": "美洲/阿根廷/拉里奧哈",
  "1H4FmE": "歐洲/烏日哥羅德",
  "1mv3LM": "亞洲/赤塔",
  "1pl9Su": "非洲/的黎波里",
  "1sEPCz": "亞洲/東京",
  "1ua619": "歐洲/布拉格",
  "23aBJh": "美洲/丹佛",
  "2DXZtH": "歐洲/哥本哈根",
  "2OWj6s": "亞洲/貝魯特",
  "2WXSh8": "亞洲/卡拉奇",
  "2qYhi8": "亞洲/香港",
  "2s/Mlc": "亞洲/堪察加",
  "2zQAXL": "歐洲/基希訥烏",
  "327IN3": "美洲/亞庫塔特",
  "339CIL": "美洲/貝里斯",
  "3Lz3cq": "太平洋/恩德伯里",
  "40b51E": "美洲/密克隆",
  "4AZ4gQ": "美洲/阿根廷/薩爾塔",
  "4D94K+": "南極洲/凱西",
  "4NXksL": "歐洲/里斯本",
  "4XF+Io": "美洲/特古西加爾巴",
  "4l3qM7": "太平洋/努美阿",
  "4neOsl": "美洲/丹馬沙文",
  "4wb1r/": "歐洲/盧森堡",
  "5M8Wkq": "美洲/阿根廷/胡胡伊",
  "5oeyFi": "美洲/阿根廷/里奧加耶戈斯",
  "5xwaJJ": "太平洋/富納富提",
  "6/dk2l": "歐洲/辛菲羅波爾",
  "6Rz5js": "非洲/阿尤恩",
  "6XgRmz": "亞洲/科布多",
  "6d5tvh": "美洲/博阿維斯塔",
  "6wYqzG": "太平洋/威克",
  "71fHGN": "美洲/圭亞那",
  "7Q7WxK": "美洲/危地馬拉",
  "7WBtG1": "太平洋/馬朱羅",
  "7euHXg": "太平洋/布干維爾",
  "7jiQ+M": "亞洲/台北",
  "82GEmf": "太平洋/瑙魯",
  "8DjTJi": "太平洋/法考福",
  "9Fhwtp": "非洲/蒙羅維亞",
  "9TfEAv": "亞洲/達卡",
  "9UC6g0": "亞洲/澳門",
  "9xN38t": "亞洲/利雅得",
  A1qgI0: "美洲/大坎普",
  A8Tpo2: "非洲/開羅",
  ADtcg9: "美洲/印第安納/彼得斯堡",
  AQnn4z: "亞洲/卡達",
  AX2M6K: "非洲/卡薩布蘭卡",
  ApEhaf: "南極洲/東方站",
  "BsRS+L": "非洲/拉哥斯",
  "CIpc+3": "亞洲/仰光",
  CJgAlM: "美洲/阿根廷/布宜諾斯艾利斯",
  CMi686: "歐洲/薩馬拉",
  CRI2Ve: "太平洋/查塔姆",
  CezJKN: "美洲/聖地亞哥",
  "Cs/zIo": "太平洋/馬克薩斯",
  CvKLCn: "太平洋/湯加塔布",
  CwyqPj: "非洲/阿克拉",
  D1tmTQ: "美洲/北達科他/中心",
  D55vg4: "非洲/突尼西亞",
  DAlYN5: "歐洲/伊斯坦堡",
  DCrzIX: "歐洲/安道爾",
  DDqHds: "非洲/喀土木",
  DQsykN: "美洲/哈瓦那",
  DVZRDC: "歐洲/奧斯陸",
  DcYI27: "非洲/馬普托",
  "EGDZo+": "亞洲/中科雷姆斯克",
  EcRGq9: "亞洲/杜拜",
  EgIxeE: "美洲/牙買加",
  "EnTK+r": "美洲/芝加哥",
  EqvKbF: "美洲/庫亞巴",
  F0y8e9: "美洲/洛杉磯",
  F465cE: "歐洲/赫爾辛基",
  F6OWRn: "太平洋/莫爾茲比港",
  FDGDXD: "歐洲/基輔",
  FEnpn4: "歐洲/柏林",
  FeFqOa: "亞洲/喬巴山",
  "G0/1QH": "美洲/帕拉馬里博",
  "GHrEk+": "亞洲/胡志明市",
  Gcuin4: "亞洲/烏蘭巴托",
  "H+kwCw": "亞洲/汶萊",
  "H/TECz": "亞洲/首爾",
  H11GhT: "亞洲/坎德加",
  HD7dNh: "亞洲/克孜勒奧爾達",
  HDlqGj: "美洲/阿根廷/圖庫曼",
  HSmzBV: "美洲/阿根廷/聖路易斯",
  I2fe6r: "亞洲/希伯倫",
  ID5HGa: "太平洋/關島",
  "IRsI+H": "亞洲/望加錫",
  IVs8gT: "印度洋/模里西斯",
  "IYKKU/": "亞洲/葉里溫",
  IYSP57: "美洲/聖塔倫",
  JGg252: "亞洲/帝力",
  "JJJ+wW": "太平洋/瓦利斯",
  JTTFhT: "太平洋/科斯雷",
  KBQ98i: "歐洲/索非亞",
  L6RwvT: "美洲/斯科斯比松",
  LFkBwb: "亞洲/吉隆坡",
  LGJGKo: "美洲/印第安納/威納馬克",
  LepYst: "美洲/阿根廷/聖胡安",
  LrC3cb: "非洲/約翰尼斯堡",
  M74J18: "太平洋/阿皮亞",
  "MS/dmQ": "歐洲/維爾紐斯",
  MYvQtB: "太平洋/波納佩",
  MhFcna: "亞洲/阿克套",
  MpIqyW: "亞洲/新西伯利亞",
  "N69J/J": "美洲/開曼群島",
  N7RBEQ: "歐洲/巴黎",
  "NLL9E/": "亞洲/新加坡",
  Nap8NB: "美洲/拉巴斯",
  NhLpaB: "亞洲/加薩",
  NwiC8y: "亞洲/巴庫",
  OPz5aV: "歐洲/華沙",
  "OSP/DU": "美洲/阿拉瓜伊納",
  "OoH/k4": "歐洲/馬爾他",
  OqlGXK: "大西洋/法羅",
  OtFyGC: "歐洲/扎波羅熱",
  P9EyMh: "亞洲/阿拉木圖",
  PRo9ZX: "美洲/大特克",
  Pbr43k: "太平洋/甘比爾",
  PdnZvE: "美洲/印第安納/諾克斯",
  Phhnuu: "太平洋/瓜達爾卡納爾",
  "PlA+93": "美洲/安克雷奇",
  "Q+QFi7": "美洲/巴拿馬",
  Q0Nwql: "美洲/拿騷",
  Q2hC7E: "亞洲/阿納德爾",
  RTFf0R: "亞洲/塔什干",
  RVtTvI: "美洲/波哥大",
  RcUwWS: "歐洲/地拉那",
  Rfu8ru: "美洲/朱諾",
  RzRPhx: "亞洲/德黑蘭",
  SRDvbw: "印度洋/聖誕島",
  SkSGFq: "美洲/亞松森",
  SqYr66: "太平洋/丘克",
  T7X3nR: "美洲/哥斯大黎加",
  TnMEvg: "歐洲/里加",
  TnQgWT: "印度洋/科科斯",
  UE61nU: "亞洲/雅加達",
  UEbt0M: "歐洲/雅典",
  UjOTtz: "歐洲/摩納哥",
  VlcnXa: "大西洋/亞速爾",
  WICb5K: "亞洲/馬加丹",
  "WJ+FQF": "亞洲/第比利斯",
  WTSjw5: "太平洋/帕果帕果",
  WUi6ng: "亞洲/古晉",
  WX1P13: "南極洲/戴維斯",
  Wb2LCw: "南極洲/羅瑟拉",
  Wg0kce: "美洲/印第安納/文森斯",
  WhpVLY: "美洲/瓜亞基爾",
  Wq4Z0k: "美洲/貝倫",
  XK8hFK: "美洲/里奧布蘭科",
  XLgiC3: "太平洋/諾福克",
  XN4sjj: "亞洲/撒馬爾罕",
  XuXXK5: "美洲/累西腓",
  YOJC0Y: "美洲/印第安納/馬倫戈",
  Yux40Y: "南極洲/帕爾默",
  "Z+d4VE": "歐洲/阿姆斯特丹",
  ZOXOj5: "南極洲/莫森",
  "aKg/xg": "南極洲/特羅爾",
  "aqHEW/": "非洲/阿爾及爾",
  aqZ1dw: "太平洋/加拉帕戈斯",
  aylTTV: "美洲/庫拉索",
  "b5+eh2": "亞洲/巴格達",
  b5GT3E: "非洲/比紹",
  bf8oMi: "太平洋/聖誕島",
  bkKBAQ: "亞洲/坤甸",
  c5lOtj: "亞洲/符拉迪沃斯托克",
  cCvy0S: "美洲/加拉加斯",
  ciyA6X: "亞洲/馬尼拉",
  cl18LV: "亞洲/烏斯季涅拉",
  d6W7pe: "歐洲/莫斯科",
  dw9A9j: "美洲/阿根廷/門多薩",
  e77Cv2: "亞洲/雅庫茨克",
  e88zL2: "亞洲/尼科西亞",
  eDz3Tw: "美洲/阿達克",
  eJqVsD: "歐洲/直布羅陀",
  "eR7v+R": "美洲/北達科他/比尤拉",
  ekhdTj: "亞洲/查亞普拉",
  "f6G4/S": "太平洋/奧克蘭",
  f6r66H: "美洲/梅諾米尼",
  fJpD6E: "非洲/恩賈梅納",
  fqXfBN: "歐洲/羅馬",
  "fxAR+x": "亞洲/烏拉爾",
  g2HLMh: "南極洲/昭和",
  gU3Odo: "美洲/紐約",
  "gibo/e": "歐洲/維也納",
  gln1VX: "美洲/薩爾瓦多",
  guiUEK: "歐洲/布加勒斯特",
  gycX1L: "美洲/費爾南多-迪諾羅尼亞",
  h5YZ1i: "歐洲/布魯塞爾",
  hI5EVU: "印度洋/留尼旺",
  hKq7PN: "歐洲/加里寧格勒",
  hL3apR: "美洲/利馬",
  hZiOxa: "美洲/波多黎各",
  hdgzx5: "太平洋/復活節島",
  hrq9xi: "歐洲/明斯克",
  iBXv4d: "美洲/梅特拉卡特拉",
  inPmEU: "歐洲/塔林",
  jRwF7m: "美洲/鳳凰城",
  jaNloj: "美洲/馬塞約",
  jtTALf: "太平洋/火奴魯魯",
  k6R7DN: "美洲/福塔雷薩",
  kLf0tS: "美洲/底特律",
  lAz3SQ: "亞洲/比什凱克",
  lNijTx: "大西洋/斯坦利",
  m5vKwe: "亞洲/加爾各答",
  mXs7zw: "美洲/錫特卡",
  mnvAEu: "美洲/印第安納/泰爾城",
  n8UW9y: "亞洲/葉卡捷琳堡",
  nYFNxR: "亞洲/庫頁島",
  o5Rywj: "美洲/阿根廷/卡塔馬卡",
  oYmVJJ: "亞洲/克拉斯諾亞爾斯克",
  ocqIaV: "印度洋/查戈斯",
  ocqwXs: "亞洲/鄂木斯克",
  okHgMB: "亞洲/杜尚別",
  pKp9LP: "美洲/印第安納/韋維",
  pNrCwc: "美洲/馬瑙斯",
  pQ5zcx: "美洲/阿根廷/烏斯懷亞",
  pcGYLU: "美洲/圖勒",
  pvDJax: "美洲/巴貝多",
  "q5++81": "歐洲/倫敦",
  q7mJWt: "美洲/博伊西",
  "qSxe/X": "歐洲/蘇黎世",
  rB9Ewl: "亞洲/阿克托別",
  rIY0ZR: "印度洋/馬爾地夫",
  rZTr8Y: "美洲/印第安納/印第安納波利斯",
  rhN321: "美洲/戈特霍布",
  rslOL6: "太平洋/塔拉瓦",
  rwZktH: "美洲/阿根廷/科爾多瓦",
  s2obSj: "太平洋/帛琉",
  s3GZlv: "美洲/西班牙港",
  slYOe6: "美洲/卡宴",
  szkWWk: "美洲/巴伊亞",
  t5CPbZ: "歐洲/都柏林",
  tHE78L: "美洲/聖多明各",
  tMDDnr: "美洲/馬那瓜",
  tUaF1F: "太平洋/紐埃",
  tlkIG3: "太平洋/斐濟",
  "tw/bjJ": "亞洲/新庫茲涅茨克",
  u0TM9W: "美洲/太子港",
  uMXTTe: "歐洲/斯德哥爾摩",
  uNiOLq: "亞洲/耶路撒冷",
  "uOkO/r": "亞洲/伊爾庫茨克",
  "utbU0+": "亞洲/阿什哈巴德",
  ux1XM2: "大西洋/百慕達",
  "v+arTX": "美洲/埃魯內佩",
  vMATTy: "亞洲/大馬士革",
  "vWWiU+": "亞洲/平壤",
  vbHpIo: "非洲/溫得和克",
  vn9nKr: "美洲/波多韋柳",
  vohVUs: "亞洲/喀布爾",
  vwtvCc: "大西洋/維德角",
  vy4zY8: "亞洲/可倫坡",
  w7kHCL: "大西洋/馬德拉",
  wDFHDz: "美洲/馬提尼克",
  "wbQai/": "大西洋/南喬治亞",
  wrZg4b: "亞洲/廷布",
  xAcBeP: "太平洋/塔希提島",
  xKA8d6: "南極洲/杜蒙迪維爾",
  "xx+5iB": "美洲/肯塔基/路易斯維爾",
  y79PlA: "亞洲/安曼",
  yaBGO1: "太平洋/皮特凱恩",
  yeltlL: "印度洋/馬埃島",
  ygabsP: "美洲/北達科他/新塞勒姆",
  z6KEn9: "太平洋/拉羅湯加",
  z98zna: "印度洋/凱爾蓋朗",
  zWABd8: "歐洲/貝爾格萊德",
  zm3ZI2: "亞洲/上海",
  zwjmMl: "亞洲/加德滿都",
  "e5x+i6": "澳洲/豪勳爵",
  gAtxKw: "南極/麥格理",
  P5aTR8: "澳洲/荷巴特",
  "nFhe/c": "澳洲/庫裡",
  e6YJm8: "澳洲/墨爾本",
  dmcxmV: "澳洲/雪梨",
  jFnCUr: "澳洲/Broken_Hill",
  i5MwAy: "澳洲/布里斯本",
  WyjEwT: "澳洲/林德曼",
  JuasJd: "澳洲/阿德雷德",
  co8c88: "澳洲/達爾文",
  qm4oIk: "澳洲/柏斯",
  "0LrMZs": "澳洲/尤克拉",
  "+E914Q": "法文（留尼汪）",
  "+FHEub": "中央阿特拉斯塔馬澤特語（阿拉伯文）",
  "/AAqs8": "葡萄牙文（赤道幾內亞）",
  "/BbMQN": "僧伽羅文",
  "/NVZFV": "葡萄牙文（安哥拉）",
  "/V7bTl": "富拉語（拉丁文，甘比亞）",
  "/YFnxw": "薩霍語",
  "/stiNv": "泰文",
  "019rDM": "葡萄牙文（葡萄牙）",
  "01GXUP": "富拉語（拉丁文，幾內亞）",
  "0BWpf+": "日文",
  "0CHkPh": "西弗里西亞文",
  "0D82eT": "克羅埃西亞文（波斯尼亞和黑塞哥維那）",
  "0fzUyn": "葡萄牙文",
  "0mDCSY": "西班牙文",
  "0rqbd/": "馬爾他文",
  "160k/R": "俄文",
  "1BHQDP": "孟加拉文（印度）",
  "1F0Uz0": "阿拉伯文（伊拉克）",
  "1J25kd": "波士尼亞文（斯拉夫文）",
  "1RqABh": "立陶宛文",
  "1dv927": "馬來文（汶萊）",
  "29JxAe": "英文（英國）",
  "2LBIWM": "依奴提圖特文",
  "2OXQzm": "丹麥文",
  "2atqiI": "奧羅莫文",
  "2hRVBA": "塞爾維亞文",
  "30RDW+": "阿拉伯文（卡塔爾）",
  "3PyL86": "英文（菲律賓）",
  "3Rvul8": "藏文（印度）",
  "3ijo+p": "荷蘭文（蘇利南）",
  "4+Zl7y": "西班牙文（薩爾瓦多）",
  "4Od9+t": "塞爾維亞文（斯拉夫文，波斯尼亞和黑塞哥維那）",
  "4U3ZpB": "法文（海地）",
  "4Xzh0/": "葡萄牙文（瑞士）",
  "4eGD8c": "富拉語（拉丁文，塞拉利昂）",
  "4fkP4F": "西班牙文（古巴）",
  "4lbmZs": "西班牙文（菲律賓）",
  "4v0pnb": "威爾斯文",
  "51lnU8": "科隆方言",
  "5KynFd": "捷克文",
  "5cyBop": "英文（印度）",
  "5ff1Qr": "特松加文",
  "5g+4ES": "韓文（北韓）",
  "5riLBC": "索馬里文（吉布提）",
  "5vu2sQ": "烏茲別克文",
  "5xPlEp": "中文（繁體）",
  "62eqUV": "北盧里文",
  "6AZb8G": "依奴提圖特文（教育課程）",
  "6G/CAW": "比利時文",
  "6am43/": "中部庫德文",
  "6ebNfH": "中文（簡體，香港特別行政區）",
  "6gtes0": "中央阿特拉斯塔馬澤特語",
  "6sur5u": "丹麥文（格陵蘭）",
  "7Gt5UH": "梵文",
  "7k8oo8": "德文（奧地利）",
  "7wLEyk": "馬恩島語",
  "7yHu97": "拉脫維亞文",
  "8MDM0L": "坦米爾文（斯里蘭卡）",
  "8oEDHH": "法文（摩洛哥）",
  "93yDUJ": "南薩米文（挪威）",
  "9cbhiA": "阿拉伯文（世界）",
  "9ftsGr": "英文（馬來西亞）",
  "9ltErv": "羅曼什文",
  "9uEO2O": "阿斯圖里亞斯文",
  AAf440: "塞索托·薩·萊博亞",
  ALhR5U: "蓋丘亞文（秘魯）",
  "AQfg7+": "法文（剛果（金））",
  AahSYM: "烏茲別克文（阿拉伯文）",
  AeHTyT: "英文（香港特別行政區）",
  "B+59h1": "蒙古文（傳統蒙古文）",
  B8qZTI: "亞美尼亞文",
  B9ZGRE: "寮文",
  BFf5tN: "法文（加拿大）",
  BgGwdt: "越南文",
  BpUgM5: "荷蘭文（博奈爾、聖尤斯塔修斯和薩巴）",
  BtqqJK: "西班牙文（洪都拉斯）",
  CBhHg6: "富拉語（拉丁文，尼日利亞）",
  CDbpEz: "冰島文",
  CFRfr5: "宗卡文",
  CauPny: "加泰隆尼亞文（法國）",
  Ccf8zA: "西班牙文（烏拉圭）",
  DBHTS0: "英文（澳大利亞）",
  DMjlMC: "德文（比利時）",
  DW0c2K: "西班牙文（智利）",
  DzWKvp: "喬治亞文",
  "EP6mL+": "曼尼普尔語",
  EREJay: "薩米文（盧勒）",
  EeOqFb: "葡萄牙文（聖多美和普林西比）",
  EzFn0W: "荷蘭文（阿魯巴）",
  F38yZH: "索馬里文",
  "FHLC+T": "德文（列支敦士登）",
  Fxzz1N: "瑞典文（芬蘭）",
  FzgpJw: "孟加拉文",
  G7wzBO: "阿拉伯文（阿拉伯聯合酋長國）",
  "GF/5qr": "塔切爾希特語",
  GGLJ5z: "科西嘉文",
  GHtHh4: "毛利文",
  "GRMM/R": "阿爾薩斯語（法國）",
  "GZ+vSv": "敘利亞文",
  GnC74O: "藏文",
  GqQl0h: "意大利文",
  GsOiFJ: "英文（南非）",
  Gwyv4n: "旁遮普文",
  "H/OHWA": "菲律賓文",
  H4fFDA: "北薩米文",
  H73FDV: "維吾爾文",
  "H7jT/h": "阿爾巴尼亞文（科索沃）",
  HDDkEc: "祖魯文",
  HVCuT9: "英文（德國）",
  HZPa57: "蘇格蘭蓋爾文",
  "Hhe/Ef": "西班牙文（巴西）",
  Hj8GDj: "古吉拉特文",
  Hq92CJ: "夏威夷文",
  HqCNsI: "挪威文",
  "I/+zqv": "英文（根西島）",
  I42yCw: "英文（加拿大）",
  IC7HXP: "提格利尼亞文",
  IDCrtf: "芬蘭文",
  IEUJ0j: "德文（盧森堡）",
  "IR/BFt": "索馬里文（埃塞俄比亞）",
  ItGyiB: "坎納達文",
  Iz1WLp: "烏爾都文",
  J1rnrw: "斯洛維尼亞文",
  J5rPWm: "西班牙文（厄瓜多爾）",
  JPFRXM: "英文（馬耳他）",
  JVK3dg: "德文",
  JkretN: "英文（芬蘭）",
  Js4yYb: "富拉語",
  "Jsem/p": "莫霍克文",
  KDsjWJ: "標準摩洛哥塔馬澤特語",
  "Kj/zcq": "法文（摩納哥）",
  LX0RZR: "富拉語（阿德拉姆文）",
  Laghvq: "基尼阿萬達語",
  Ll0N3I: "切羅基文",
  MESBkg: "科薩文",
  MJQbru: "巴什基爾文",
  Mbp9v6: "阿拉伯文（敘利亞）",
  Mt9Ngn: "希伯來文",
  N4oAho: "索托文",
  NLZIcM: "荷蘭文（比利時）",
  NObQUE: "南非荷蘭文",
  "NV+8r2": "馬普切文",
  NVQG0j: "迪維希文",
  Nevbjx: "富拉語（拉丁文，毛里塔尼亞）",
  NfTD2i: "西班牙文（委內瑞拉）",
  NhbCYP: "瓦倫西亞文（西班牙）",
  NtuQMz: "葡萄牙文（澳門特別行政區）",
  "O/Bw0H": "塞爾維亞文（拉丁文，科索沃）",
  OKUlj2: "匈牙利文",
  OSMagZ: "法文",
  Oju9iC: "蒙古文",
  P23feN: "西班牙文（貝里斯）",
  "P91ei/": "塔吉克文",
  PE6jNM: "西班牙文（阿根廷）",
  PO8fNg: "葡萄牙文（東帝汶）",
  POQTzM: "法文（塞內加爾）",
  PSoXmh: "歐里亞文",
  Pa7aMt: "阿拉伯文（黎巴嫩）",
  Pl3tfG: "瑞典文",
  PsNb95: "愛爾蘭文",
  Q8eBZk: "荷蘭文",
  QBwWZp: "奧羅莫文（肯尼亞）",
  Qcitp4: "爪哇文",
  Ql51WU: "馬拉地文",
  R1VwTR: "巴斯克文",
  R325ks: "西班牙文（拉丁美洲）",
  R34HBa: "阿拉伯文（阿曼）",
  RRmxSU: "蓋丘亞文",
  RTbzBi: "上索布文",
  RWrQ2K: "阿拉伯文（阿爾及利亞）",
  "RqsM+G": "西班牙文（尼加拉瓜）",
  SUF5bX: "英文（奧地利）",
  Sg9DRE: "法文（瑞士）",
  SlWjJ2: "南薩米文",
  T9IHrN: "盧森堡文",
  TQ7V9A: "阿拉伯文（摩洛哥）",
  Tddnlb: "泰盧固文",
  Tq0aui: "高棉文",
  UAHDtf: "馬拉雅拉姆文",
  UGFi6Q: "阿拉伯文（約旦）",
  Uc1vOK: "阿爾巴尼亞文",
  "V+BaHn": "普什圖文",
  V223G2: "富拉語（拉丁文，布基納法索）",
  V2uMRt: "坦米爾文",
  VJbQAt: "西班牙文（巴拿馬）",
  VKt1qn: "尼泊爾文（印度）",
  VuQRaN: "意大利文（瑞士）",
  W6zXNX: "西班牙文（多明尼加共和國）",
  WK7YIm: "阿拉伯文（也門）",
  WQtbS0: "英文",
  WU7Urn: "土耳其文",
  WUUTG8: "土庫曼文",
  Wlr6BV: "加泰隆尼亞文（意大利）",
  XAmFMw: "克羅埃西亞文",
  XNXAkr: "蓋丘亞文（厄瓜多爾）",
  XT8v2Z: "加泰隆尼亞文",
  XjbxJQ: "南非荷蘭文（納米比亞）",
  Xkmde4: "中文（簡體，澳門特別行政區）",
  Xx527p: "北薩米文（瑞典）",
  Y7CQhy: "瑞士德文",
  Y8mZTh: "英文（牙買加）",
  Y941O5: "斯洛伐克文",
  YNjb1t: "法羅文",
  Ygp3rn: "波士尼亞文",
  "Z/MVyq": "教會斯拉夫文",
  ZCh9e6: "下索布文",
  ZQtURc: "羅馬尼亞文（摩爾多瓦）",
  ZjrmiJ: "紹納文",
  "Zki/XJ": "哈薩克文",
  a9U6ge: "康沃爾文",
  aO94Wj: "烏爾都文（印度）",
  "aTZE+x": "克什米爾文（天城文）",
  aiXFTk: "富拉語（拉丁文，加納）",
  bDNNJp: "馬來文（印尼）",
  bLqBa4: "英文（紐西蘭）",
  bRIPjy: "英文（以色列）",
  "bT+IsS": "馬來文（新加坡）",
  bVuD3F: "阿拉伯文",
  bfp8tQ: "格陵蘭文",
  c3rP5p: "英文（斯洛維尼亞）",
  cJbw13: "中文（繁體，台灣）",
  cQRIur: "英文（新加坡）",
  d5MtIX: "印尼文",
  dEIOuD: "波蘭文",
  dPzT2w: "布列塔尼文",
  drEx3O: "斯瓦希里文",
  e9Fovw: "帕皮阿門托文",
  eGmwHh: "英文（瑞士）",
  eSg76K: "英文（直布羅陀）",
  eSmbEf: "愛爾蘭文（英國）",
  eWnJnC: "印度文",
  efy66J: "車臣文",
  "f+NB92": "西班牙文（秘魯）",
  "f/8iNS": "富拉語（拉丁文，喀麥隆）",
  "f5+iem": "西班牙文（墨西哥）",
  f6Viji: "普什圖文（巴基斯坦）",
  fkHabQ: "基切文",
  fv9aDa: "薩米文（伊納里）",
  "gHco+M": "俄文（摩爾多瓦）",
  gOsLMk: "馬達加斯加文",
  gWx9ey: "塞爾維亞文（拉丁文，黑山）",
  gfmlPE: "英文（愛爾蘭）",
  glnMAY: "塔切爾希特語（拉丁文）",
  gvaI7A: "索馬里文（肯尼亞）",
  "h6q+Tn": "普魯士文",
  h9YX8r: "坦米爾文（新加坡）",
  "hEPDg/": "奧克語",
  hNSwvJ: "富拉語（拉丁文，賴比瑞亞）",
  hcX72z: "坦米爾文（馬來西亞）",
  hmzrxz: "北薩米文（芬蘭）",
  hr7Bt0: "葡萄牙文（幾內亞）",
  i4jvwu: "中文",
  "i5/TH8": "西班牙文（赤道幾內亞）",
  "iI431+": "英文（荷蘭）",
  iKxsEO: "尼泊爾文",
  iTiaM1: "瓜拉尼文",
  iXn58z: "亞塞拜然文（斯拉夫文）",
  ifdXl3: "韓文",
  jG6ZfL: "德文（意大利）",
  jGXHMX: "塞爾維亞文（拉丁文，波斯尼亞和黑塞哥維那）",
  "jHvE/3": "恩科文",
  joVZ4M: "阿拉伯文（埃及）",
  "k+bU6l": "荷蘭文（聖馬丁）",
  k6RCbu: "葡萄牙文（盧森堡）",
  kW1ixl: "斯瓦希里文（烏干達）",
  l8f1rC: "喀什米爾文",
  lGAoQJ: "斯瓦希里文 （坦桑尼亞）",
  "lig/ia": "博多語",
  lwerC3: "西班牙文（美國）",
  "m+zQs1": "伊博文",
  m421XM: "烏克蘭文",
  "mP+2ZR": "英文（特立尼達和多巴哥）",
  mQ30Fl: "英文（福克蘭群島）",
  mQPNAb: "辛迪文",
  mgFsmM: "英文（丹麥）",
  "mkyn/R": "阿拉伯文（巴林）",
  mq4oU3: "英文（澤西島）",
  mvxq4r: "加利西亞文",
  n86rIs: "吉爾吉斯文",
  naThLg: "希臘文",
  ncJAOw: "緬甸文",
  nfKkEe: "富拉語（拉丁文，尼日爾）",
  nzfKPJ: "法文（喀麥隆）",
  "oCgi+u": "阿姆哈拉文",
  "oh7xe+": "薩米文（盧勒，挪威）",
  oiHWuC: "德文（瑞士）",
  ono6Zw: "西班牙文（危地馬拉）",
  ouSGKF: "薩米文（斯科爾特）",
  pJE11U: "塞茨瓦納文（博茨瓦納）",
  pVxDdM: "馬贊達蘭文",
  pcWfuB: "塞茨瓦納文",
  pdfcvu: "法文（象牙海岸）",
  pjF6Nn: "索托文（萊索托）",
  pqIrOS: "阿拉伯文（突尼西亞）",
  q2N4yn: "塞爾維亞文（斯拉夫文）",
  qQDW8M: "法文（馬里）",
  qRbMrx: "約魯巴文",
  qYdUNv: "中央阿特拉斯塔馬澤特語（提菲納文）",
  qu9gJ5: "阿拉伯文（利比亞）",
  qwSYAN: "葡萄牙文（莫三比克）",
  r8ZWqf: "新挪威文",
  rcixhA: "荷蘭文（庫拉索）",
  rcmyN3: "波斯文（阿富汗）",
  rk5DA1: "英文（比利時）",
  sBC8AY: "辛迪文（天城文）",
  sHbxv8: "英文（伯利茲）",
  sRuB7H: "馬來文",
  sl0qaQ: "阿拉伯文（科威特）",
  sliV2n: "西班牙文（巴拉圭）",
  syMU2g: "法文（比利時）",
  tQJpug: "加泰隆尼亞文（撒丁島）",
  tQi27b: "孔卡尼文",
  tRgqyZ: "塞爾維亞文（斯拉夫文，科索沃）",
  tdrfAE: "英文（加勒比地區）",
  u0KReQ: "意大利文（梵蒂岡城）",
  u61cWR: "西班牙文（哥倫比亞）",
  u78bW4: "馬其頓文",
  uCI04p: "愛沙尼亞文",
  uVRPPZ: "韃靼文",
  ubfX8q: "英文（辛巴威）",
  uh1OQN: "沃洛夫文",
  upv4s2: "葡萄牙文（佛得角）",
  vSG3D5: "西班牙文（哥斯大黎加）",
  viRRMu: "塞爾維亞文（斯拉夫文，蒙特內哥羅）",
  vo99Cy: "英文（蒲隆地）",
  vuf8EY: "英文（英屬維爾京群島）",
  vxR1y4: "豪薩文",
  wVqnrV: "波斯文",
  wra0CG: "斯瓦希里文（剛果）",
  wtZRFn: "弗留利文",
  x0KMJr: "英文（曼島）",
  xXkK79: "蒙古文（傳統蒙古文）",
  xeXtGt: "英文（瑞典）",
  xgB0JY: "阿薩姆文",
  xoMuR7: "瓦爾瑟文",
  "xzWaZ/": "西班牙文（波多黎各）",
  "y//NHV": "亞塞拜然文",
  y7nOlh: "保加利亞文",
  ydTOo2: "法文（盧森堡）",
  z0tSbC: "奧塞梯文",
  z1VBi8: "羅馬尼亞文",
  zBWf5p: "國際語",
  zWU1xI: "西班牙文（玻利維亞）",
  "05KCjo": "App icon：",
  "11uVJ/": "接收物件",
  "1Qoc6t": "行程名稱：",
  "2JW1Pt": "請選擇是否同時寄送郵件",
  "70JpVD": "行程名稱",
  "9AsSO/": "請選擇是否同時發送簡訊",
  "AH+jWQ": "Windows應用程式",
  Axagls: "請選擇結束時間",
  FNIJXx: "請選擇捲動播放",
  Fir0oq: "請選擇通知類型",
  G4qgGm: "所有使用者",
  G5gg2V: "公告標題為必填",
  IWPf2S: "公告詳情",
  IbWDVg: "版本號碼必填",
  Km733q: "請選擇開始時間",
  L24ioQ: "標題",
  L80hmc: "公告標題不得超過30字元",
  NDjXUx: "輸入指令部署檔案：",
  "Oex59+": "返回清單",
  QHc9Qg: "公告內容",
  QNomO6: "請輸入版本號碼",
  Qpcx6F: "公告內容為必填",
  RQyKsa: "平台公告",
  TiK9WZ: "進程名稱必填",
  TvOGLc: "部署檔案指令",
  UHuNzJ: "請輸入指令",
  WtPk7v: "同時發送簡訊",
  XbIN5K: "請輸入程式名稱",
  XeIKK7: "通知中心",
  ZqioaF: "通知標題",
  aGxRt2: "內容",
  cr1ymH: "請選擇寄送時間",
  dY3og7: "上傳App icon：",
  eFDqHN: "上傳Windows應用程式成功",
  eSfTZf: "上傳Windows應用程式",
  "ghKe/+": "行程名稱",
  "h5yj+x": "請輸入行程名稱",
  jAJbuk: "通知公告",
  l36W55: "滾動播放",
  lqQKL4: "透過進程名稱新增",
  mKKd1R: "請選擇接收物件",
  q9PHLT: "暫無公告",
  wYygRu: "發送人",
  xXdMar: "指定使用者",
  xx40g7: "公告標題",
  yKFvYY: "同時發送郵件",
  yfhtRM: "附件",
  z5L9EV: "更新Windows應用程式",
  "bhv+8O": "下載中",
  xzmRTb: "僅顯示近7天的歷史紀錄",
  "yrR/HC": "安裝中",
  ibYzs0: "程式名稱：{name}",
  ivzCMK: "該應用程式無法解析。",
  mJBhe1: "檔案同步最多允許新增10個檔案",
  "6oXjFu": "上傳格式有誤",
  KetfTt: "圖片最大尺寸：500KB",
  baNBmh: "圖片大小不能超過500KB",
  tAjFr2: "圖片格式：PNG、JPG、JPEG、BMP、GIF、SVG、WEBP",
  "3K02K/": "wifi設定填寫不全",
  "5Cm9U3": "訊息通知",
  "Y6Q+iJ": "請填寫wifi設定",
  tugHWJ: "返回公告清單",
  "x/FhNQ": "查看通知",
  "+GRUnH": "亞洲/科布多",
  "+IL2pH": "亞洲/利雅得",
  "+J2Dyk": "美洲/亞松森",
  "+Ny8AK": "美洲/波多黎各",
  "+RWig5": "西班牙文（玻利維亞）",
  "/2Wzyw": "美洲/薩爾瓦多",
  "/rG/9z": "美洲/庫拉索",
  "0AuprP": "太平洋/湯加塔布",
  "0X3KFO": "CPU溫度",
  "0vIw5o": "美洲/波哥大",
  "1YfhFP": "亞洲/帝力",
  "2+A7qs": "南極洲/莫森",
  "2+ec6P": "美洲/丹馬沙文",
  "2FPNxz": "亞洲/杜拜",
  "32RJkL": "美洲/阿根廷/聖路易斯",
  "33VS8L": "美洲/馬塞約",
  "36csPo": "歐洲/蘇黎世",
  "3KlQfs": "澳洲/布里斯本",
  "3LAnU7": "大西洋/法羅",
  "3MaR6w": "歐洲/塔林",
  "3NE037": "亞洲/阿什哈巴德",
  "3svavz": "美洲/密克隆",
  "42xSxy": "亞洲/新西伯利亞",
  "4LAo5S": "美洲/梅特拉卡特拉",
  "4Sw/d9": "亞洲/克拉斯諾亞爾斯克",
  "4T/bEM": "美洲/印第安納/韋維",
  "4WaJo8": "美洲/斯科斯比松",
  "4Wgk5f": "歐洲/安道爾",
  "4ZRHuu": "大西洋/南喬治亞",
  "4cXOI/": "亞洲/葉里溫",
  "4jryq3": "美洲/北達科他/新塞勒姆",
  "4sqSH4": "亞洲/漢德加",
  "564gFy": "非洲/阿克拉",
  "6SQvm5": "亞洲/坤甸",
  "6X6msx": "儲存使用情況",
  "6xnHrJ": "歐洲/柏林",
  "72KWoU": "澳洲/雪梨",
  "778/Xc": "美洲/德古西加巴",
  "7JA1Vf": "美洲/阿根廷/門多薩",
  "7L+CJm": "歐洲/赫爾辛基",
  "7geAkY": "美洲/阿根廷/布宜諾斯艾利斯",
  "7teo40": "太平洋/丘克",
  "87d7yX": "太平洋/瓜達康納爾",
  "8Gi8qJ": "澳洲/布羅肯希爾",
  "8eL/hC": "亞洲/耶路撒冷",
  "8hJsOE": "亞洲/曼谷",
  "8qYKWy": "太平洋/查塔姆",
  "8woxjy": "亞洲/吉隆坡",
  "A3y/jB": "美洲/阿根廷/里奧加耶戈斯",
  ACHtOA: "亞洲/堪察加",
  AFZYEo: "亞洲/汶萊",
  ALGNzc: "亞洲/馬加丹",
  AWhHY3: "美洲/里奧布蘭科",
  ApnLV0: "亞洲/阿拉木圖",
  AqKGKn: "亞洲/雅加達",
  As1lP0: "印度洋/凱爾蓋朗",
  "Aytpe/": "歐洲/摩納哥",
  B6rikn: "美洲/印第安納/印第安納波利斯",
  B9NkmN: "歐洲/盧森堡",
  BXdJNy: "大西洋/斯坦利",
  BgYCgo: "南極洲/凱西",
  C21hEn: "歐洲/貝爾格勒",
  C7HjWu: "歐洲/阿姆斯特丹",
  CBkGYl: "非洲/馬普托",
  CC9Jw3: "亞洲/望加錫",
  CIImWq: "太平洋/馬久羅",
  "CNMmH/": "亞洲/雅庫茨克",
  CR8w2m: "美洲/大特克",
  CUsFOe: "美洲/卡宴",
  D2gXtv: "美洲/梅諾米尼",
  D4VBw5: "南極洲/杜蒙迪維爾",
  DincSy: "澳洲/洛德豪",
  DoPuye: "亞洲/大馬士革",
  "E/3oPZ": "亞洲/澳門",
  E2NUw6: "非洲/約翰尼斯堡",
  EJA24j: "太平洋/諾福克",
  EgGVTj: "太平洋/恩德伯里",
  EhPWhM: "美洲/庫亞巴",
  EmxcJt: "美洲/亞庫塔特",
  Ewhh7n: "歐洲/索非亞",
  FXD37C: "美洲/巴拿馬",
  FsXquv: "亞洲/平壤",
  GIHcco: "美洲/努克",
  GIwuGT: "歐洲/布魯塞爾",
  GNkv6K: "非洲/阿尤恩",
  "H8+X66": "亞洲/坎德加",
  HDVqMh: "美洲/阿根廷/聖胡安",
  HEpXP8: "美洲/丹佛",
  HOEyDX: "美洲/拉巴斯",
  HS4Jyv: "歐洲/烏日哥羅德",
  Hh1tUP: "美洲/瓜亞基爾",
  HkGIFU: "南極洲/戴維斯",
  HoSy6c: "太平洋/夸賈林",
  HuSwkp: "亞洲/烏斯季涅拉",
  HzSbcD: "南極洲/特羅爾",
  I3bX6d: "亞洲/烏魯木齊",
  IBZBgD: "歐洲/伊斯坦堡",
  IHXrCK: "美洲/洛杉磯",
  IKeroX: "亞洲/查亞普拉",
  ILjenb: "美洲/印第安納/馬倫戈",
  IgbKn9: "亞洲/胡志明市",
  InLlSF: "美洲/帕拉馬里博",
  J5iABC: "亞洲/卡拉奇",
  JHjx5l: "美洲/安克雷奇",
  "JURm/W": "南極洲/帕爾默",
  "Jc5/LG": "亞洲/鄂木斯克",
  JrjIBq: "美洲/太子港",
  K9TF6H: "亞洲/香港",
  KAKu2d: "太平洋/努美阿",
  KEr7iI: "太平洋/帛琉",
  "KaS+yS": "美洲/哥斯大黎加",
  KyBesr: "太平洋/拉羅湯加",
  M3Bd2i: "太平洋/皮特凱恩",
  MAVhWe: "歐洲/奧斯陸",
  MAWdwn: "亞洲/科倫坡",
  McxhaP: "美洲/伯利茲",
  MeSuny: "美洲/巴巴多斯",
  MmTr9O: "非洲/開羅",
  Mr4JiU: "印度洋/查戈斯",
  MxWLCa: "太平洋/馬克薩斯",
  NW4CG5: "非洲/的黎波里",
  NWpmvK: "歐洲/莫斯科",
  Nd0dlz: "美洲/阿根廷/卡塔馬卡",
  NhHERf: "非洲/喀土穆",
  O2VzkZ: "歐洲/直布羅陀",
  OEWR5m: "美洲/累西腓",
  OPvCOV: "大西洋/雷克雅未克",
  OdITFl: "印度洋/科科斯",
  Oj7H2e: "歐洲/馬爾他",
  OnT6Rq: "美洲/阿根廷/薩爾塔",
  P5ijks: "亞洲/赤塔",
  P8Gz8g: "亞洲/撒馬爾罕",
  P8fuMA: "太平洋/阿皮亞",
  PE4Jv1: "歐洲/加里寧格勒",
  "PHe5b/": "美洲/聖保羅",
  PQTASm: "非洲/奈洛比",
  PSTE5v: "亞洲/德黑蘭",
  "Pr/HJJ": "美洲/圖勒",
  Q93ucv: "歐洲/都柏林",
  Q9eZjv: "美洲/利馬",
  QIrZ4x: "太平洋/科斯雷",
  QXW2mv: "美洲/阿根廷/图库曼",
  QlNyHt: "亞洲/首爾",
  RWGdDh: "歐洲/布加勒斯特",
  RWhf30: "太平洋/奧克蘭",
  RbCEhx: "美洲/肯塔基/路易斯維爾",
  RdB8rs: "美洲/肯塔基/蒙蒂塞洛",
  Ri5GFC: "歐洲/伏爾加格勒",
  Rzjtg0: "南極洲/麥夸里",
  "SB+r6t": "印度洋/聖誕島",
  "SDmnE+": "亞洲/安曼",
  SO2rVX: "非洲/溫得和克",
  TSIb1O: "亞洲/貝魯特",
  TVzP2K: "太平洋/復活節島",
  TmXGJf: "太平洋/帕果帕果",
  Tp6vAo: "大西洋/亞速爾",
  "Tvk1/+": "亞洲/巴庫",
  TxnfAW: "歐洲/辛菲羅波爾",
  UU6RxP: "太平洋/法考福",
  "W+BF0N": "歐洲/基輔",
  WF6jLL: "亞洲/伊爾庫次克",
  WGbNbT: "歐洲/羅馬",
  WH83gM: "澳洲/尤克拉",
  WM9F6N: "歐洲/布達佩斯",
  WT4u2Q: "非洲/比紹",
  Wd588a: "美洲/朱諾",
  "X+krOQ": "歐洲/倫敦",
  XG3VTC: "印度洋/馬爾地夫",
  XGLQKt: "印度洋/模里西斯",
  XJz9XQ: "美洲/芝加哥",
  XcLHzQ: "美洲/聖多明哥",
  XgCqrC: "亞洲/古晉",
  "Xs2qb/": "亞洲/上海",
  YUT4gj: "歐洲/里斯本",
  YZ2GGD: "亞洲/新加坡",
  "Ywxpi/": "印度洋/馬埃島",
  Z0uRcM: "亞洲/達卡",
  ZKdJhk: "美洲/博阿維斯塔",
  ZZib2d: "澳洲/荷巴特",
  Zjiy1h: "太平洋/瑙魯",
  ZnA7Nz: "亞洲/希伯倫",
  a25tfu: "亞洲/加爾各答",
  a4hALt: "歐洲/薩馬拉",
  aIkFIc: "歐洲/里加",
  aJXo8B: "亞洲/庫頁島",
  an8KV9: "歐洲/斯德哥爾摩",
  "bPKD9+": "美洲/巴伊亞",
  bpugpH: "太平洋/加拉巴哥斯",
  bwibOg: "美洲/印第安納/特爾城",
  bwxucD: "南極洲/羅瑟拉",
  byIMHD: "美洲/印第安納/威納馬克",
  cGo7xU: "歐洲/維也納",
  cL4iBR: "太平洋/威克",
  cR6lQr: "美洲/紐約",
  cY9R69: "亞洲/仰光",
  "cdP+DQ": "記憶體負載",
  cfqioE: "美洲/馬提尼克",
  ckkIgb: "美洲/聖塔倫",
  "d+p45H": "南極洲/東方站",
  "dD/ri/": "太平洋/埃法特",
  dVOPAi: "設備離線監控",
  dmQidl: "太平洋/瓦利斯",
  dnhrx5: "歐洲/雅典",
  dsc2e1: "美洲/大坎普",
  dwtkZ7: "大西洋/佛得角",
  e7x56t: "美洲/埃魯內佩",
  eCaCt4: "歐洲/哥本哈根",
  eJ850A: "美洲/加拉加斯",
  eUPrSB: "美洲/阿根廷/科爾多瓦",
  "eiH+8b": "非洲/恩賈梅納",
  esrASO: "美洲/馬瑙斯",
  "f/kdJq": "亞洲/杜尚別",
  f2wvqe: "亞洲/克孜勒奧爾達",
  fRTjpp: "美洲/西班牙港",
  felOXC: "歐洲/明斯克",
  "fr++q+": "美洲/北達科他/中心",
  fwXmSX: "印度洋/留尼汪",
  g8yytK: "已讀",
  g9Ro8s: "亞洲/廷布",
  gCnWv3: "美洲/危地馬拉",
  "gWP+OK": "美洲/波多韋柳",
  gY9Idz: "通知內容",
  hMJvQy: "亞洲/阿克托別",
  hMvFT8: "太平洋/斐濟",
  i9kfO3: "澳洲/柏斯",
  ia2KGW: "澳洲/林德曼",
  iemojj: "美洲/印第安納/彼得斯堡",
  iktlFx: "非洲/拉哥斯",
  ioR1tU: "澳洲/墨爾本",
  irTGxZ: "美洲/拿騷",
  iuG5L2: "太平洋/富納富提",
  jArote: "亞洲/喬巴山",
  jGg3Qb: "大西洋/百慕達",
  "kPnKK/": "太平洋/塔拉瓦",
  kQfkBY: "太平洋/紐埃",
  kX80z5: "非洲/卡薩布蘭卡",
  kb4vnt: "亞洲/第比利斯",
  kibwvT: "美洲/阿拉瓜伊納",
  klPlFN: "大西洋/馬德拉",
  ktaxSw: "未讀",
  kzL66g: "美洲/錫特卡",
  l0DTVX: "歐洲/基希訥烏",
  l3HZXk: "美洲/阿根廷/胡胡伊",
  lUObgG: "亞洲/新庫茲涅茨克",
  "lY+G1f": "歐洲/扎波羅熱",
  ldw5JF: "美洲/哈瓦那",
  ldz3Qp: "美洲/諾姆",
  "luv+ak": "南極洲/昭和",
  m372k4: "亞洲/阿克套",
  mC90qt: "美洲/費爾南多-迪諾羅尼亞",
  maWrSV: "亞洲/卡達",
  mpmcYh: "美洲/牙買加",
  mzw9vO: "亞洲/海參崴",
  nFRGgT: "亞洲/尼科西亞",
  nG6bDa: "太平洋/波納佩",
  nNIaxy: "澳洲/柯里",
  "nTx/do": "非洲/蒙羅維亞",
  ndfOI1: "亞洲/塔什干",
  nfV4cd: "太平洋/莫爾斯比港",
  nt7Sni: "美洲/鳳凰城",
  "oNgMl/": "歐洲/華沙",
  ox9xcC: "亞洲/烏蘭巴托",
  "p/Y+A9": "亞洲/烏拉爾",
  p60kqM: "美洲/印第安納/諾克斯",
  "pDAAq+": "太平洋/聖誕島",
  "pH7u/B": "歐洲/布拉格",
  pctdGN: "太平洋/大溪地",
  pkQvvT: "亞洲/加薩",
  qZesUE: "太平洋/布干維爾",
  qm1rPH: "美洲/阿達克",
  qrxb3P: "美洲/馬那瓜",
  qyspJO: "亞洲/巴格達",
  rB8hza: "美洲/博伊西",
  rDnYpj: "美洲/底特律",
  "rSU+yK": "歐洲/地拉那",
  rhrAj5: "亞洲/馬尼拉",
  sCbQzB: "太平洋/關島",
  ssEhAp: "澳洲/達爾文",
  tGy5jw: "亞洲/比什凱克",
  tb5CXr: "歐洲/巴黎",
  u8OEeb: "亞洲/阿納德爾",
  umaIEg: "美洲/阿根廷/烏斯懷亞",
  "uq/hF0": "亞洲/東京",
  v1R8a6: "美洲/圭亞那",
  v9QImt: "亞洲/喀布爾",
  vvPXpH: "亞洲/加德滿都",
  w6MqYv: "美洲/貝倫",
  "wHl/4A": "澳洲/阿德萊德",
  wQ6hxa: "非洲/突尼斯",
  wTov5v: "美洲/福塔雷薩",
  wu6z2j: "太平洋/甘比爾",
  xC5dF9: "非洲/阿爾及爾",
  xV1AHg: "亞洲/葉卡捷琳堡",
  xV72W5: "美洲/聖地亞哥",
  "xefyX+": "美洲/北達科他/比尤拉",
  yBB7Af: "美洲/阿根廷/拉里奧哈",
  yjTwMp: "亞洲/台北",
  yk6eIX: "太平洋/檀香山",
  z4BN1R: "美洲/開曼群島",
  zMTRSM: "CPU負載",
  zOIpOr: "美洲/印第安納/文森斯",
  zooIwl: "歐洲/維爾紐斯",
  "/+bsEl": "美洲/蒙特雷",
  "/Gtqfz": "美洲/梅里達",
  "22S38U": "美洲/阿蒂科坎",
  "3TyuhP": "美洲/奧希納加",
  "3nz5UA": "非洲/阿比讓",
  "5LGVs8": "美洲/伊努維克",
  "5hwp3A": "美洲/溫尼伯",
  "75rZvt": "美洲/納爾遜堡",
  B1cpxi: "美洲/巴伊亞班德拉斯",
  DB1i32: "美洲/奇瓦瓦",
  EjYbG7: "大西洋/加那利",
  JJlhYG: "美洲/蒙克頓",
  JK7opY: "美洲/雷尼河",
  JMiQE7: "美洲/斯威夫特卡倫特",
  JNgj9q: "美洲/溫哥華",
  LQs9br: "美洲/克雷斯頓",
  TV0vfT: "美洲/埃莫西約",
  TtsBNI: "美洲/聖伊莎貝爾",
  "V/ychw": "美洲/聖約翰",
  V3RDY8: "美洲/劍橋灣",
  WrrSc3: "歐洲/馬德里",
  XAJf4I: "美洲/黃色刀",
  Xf2rFn: "美洲/馬薩特蘭",
  "YIziP+": "美洲/蘭金因萊特",
  Zw6GOE: "美洲/里賈納",
  cvhrwM: "美洲/龐納唐",
  d4TeTf: "美洲/懷特霍斯",
  dS4Q9B: "美洲/埃德蒙頓",
  dXgU6w: "美洲/馬塔莫羅斯",
  damxMJ: "美洲/尼皮貢",
  hrTtyK: "美洲/道森‧克里克",
  i7y8PO: "非洲/休達",
  mYnwj6: "美洲/伊魁特",
  mZSYZK: "美洲/坎昆",
  n4UQqL: "美洲/道森",
  pIep8S: "美洲/墨西哥城",
  pZHBxH: "美洲/雷索盧特",
  puzgCP: "美洲/多倫多",
  sf6FE5: "美洲/格萊斯貝",
  trLh1J: "美洲/蒂華納",
  vmXV5r: "布蘭克-薩布隆",
  x062Q4: "美洲/哈利法克斯",
  x5t5ol: "美洲/桑德貝",
  x8MKpa: "美洲/鵝灣",
  qhku2P: "(暫不支援windows 7)",
  LjaYAu: "(應用設定後設備將會自動重啟)",
  SsOQaU: "必須設定Android裝置路徑",
  ftJgyV: "必須勾選一個設備",
  tp71Dv: "必須設定Windows裝置路徑",
  "+x/2kt": "設備規則",
  "781mpm": "3. 公司預設命名規則",
  EJYMZz:
    "關閉後，您可自行下載新版Ora安裝，或透過裝置指令-Ora更新進行手動更新。",
  QWNGGT: "設備數量",
  QkSHo2: "關閉自動更新後，裝置上Ora版本差異可能會導致部分功能無法使用",
  RFear4: "2. 設備可更新時段（當地時間）",
  VUYwkz: "請選擇應用程式",
  Z8Wkvb: "開啟後，若Ora有新版本時將自動下載與更新。",
  bc4BgP: "Ora最後上線時間",
  c5daOt: "門市數 ({num})",
  qDHqff: "自動重啟",
  zbqD5q: "值",
  FtTdh0: "1. {ora}自動更新",
  Em0SLE: "重啟",
  Gvm3Ry:
    "是否確認重新啟動（{name}）的{​​appName}？重新啟動後將繼續執行應用程式監控。",
  Ixi8kg: "重啟提醒",
  bbMhTk: "是否確認重新啟動？",
  "99tjyG": "IP",
  "9a/nvJ": "操作結果",
  BdDDD0: "設備日誌",
  MbqxKj: "模板名稱",
  OjLqmy: "未知",
  V6d4dz: "操作詳情",
  "hD/l+2": "操作類型",
  "s+OQvW": "操作者",
  yc8eep: "選擇結果",
  "/5RjKG": "token 失效",
  "0nwYmb": "全部通知類型",
  "ZC7J/S": "通知類型",
  pm5kAg: "內容請在詳情查看",
  y8e4w8: "僅在裝置重新啟動後生效",
  vjxfR4: "(exe安裝程式、msi檔案)",
  "8DORrA": "USB埠",
  AFx0WP: "搜尋類型",
  GyqBiS: "列印訊息",
  L3HWwz: "裝置描述",
  OuXnTb: "是否確認重設該USB埠?",
  "QZM++f": "是否確認重設該印表機?",
  RCjVsb: "設備ID",
  RJpihQ: "是否確認已停用該USB連接埠?",
  adMZWx: "新增週邊設備",
  j3iWkN: "印表機不能重複",
  kL3ndq: "是否移除該印表機?",
  r8lAlx: "週邊管理",
  wIFJtf: "未連接",
  zKsJJS: "是否確認啟用該USB埠?",
  "zY36V+": "已連線",
  "2Rco7+": "上傳時間：",
  "5JrKIs": "功能部署已排定在選定的發佈時間。",
  E62yo0: "功能部署失敗，正在重試。",
  HI9nIp: "移除檔案",
  IX5jed: "設定檔部署狀態",
  Mxw3XE: "bat檔沒有命名為install或uninstall",
  "N3h+Aq": "此功能部署失敗",
  N9kr00: "轉移後卸載app",
  "OY+bYK": "確認，以後不再顯示",
  PZD5BD:
    "此項目已被【{name}】設定檔所使用，無法刪除，若要刪除項目請至設定檔中移除項目",
  Pzsa4g: "功能部署已準備就緒",
  RzXkm3: "黑名單啟用",
  SzN0Xf: "解除Device Owner",
  VvutjQ: "功能",
  XPoLPc: "功能部署已收到，即將處理。",
  Xsx53E: "請問您確認要移除此檔案嗎？",
  c7ABGP: "功能部署正在等待 Ora 的回應",
  d6mNdO: "白名單啟用",
  f9tP6e: "請問您確認要移除此Windows應用程式嗎？",
  hmCei2: "移除後卸載app",
  ii1TCF: "(請把壓縮包中的bat檔命名為install或uninstall)",
  mmGD7U: "功能部署正在進行中。",
  uL4MGN: "請問您確認要移除此Android應用程式嗎？",
  wzPSgE: "黑名單/白名單",
  xAk1ic: "此功能已成功部署",
  yWzW01: "(exe安裝程式、msi檔、zip壓縮包)",
  yvnu2T: "設定範本名稱",
  "CqT/5i": "此文件已被共享，确认要移除此文件吗？",
  wboZY3: "回報時間",
  "6kNt8v": "下一小時",
  Rkh3mc: "上一小時",
  "+/nbWD": "下次可變更時間{time}",
  "1ULJr+": "單一應用模式",
  CxuMXm: "必須新增一個應用程式",
  Gp3iu0: "上傳本地桌布",
  M0GExq: "若裝置已存在app，移除原本版本重新安裝",
  OYWCEU: "本地上傳應用程式",
  PyHYs3: "關閉VNC連線",
  QZCAIP: "應用程式ID",
  "X+8ega": "Kiosk 模式選擇",
  "bLP2/B": "查看設定套用狀態",
  bneXBI: "變更提示",
  czLSET: "手動新增應用程式",
  eg9Cwk: "從目前定位公司",
  f8ijF3: "命令已下發",
  i8wqAy: "上傳本機應用程式",
  oiRBSj: "確認後裝置將套用新的設置，確定要套用嗎？",
  "qG2/EZ": "本地檔案上傳",
  "qH+vs7": "白名單",
  qTgFpp: "從帳號所屬公司",
  qwHBkg: "沒有設定變更的記錄，設備皆採用預設設定",
  sB85Wu: "本地上傳",
  uqEE8V: "此設定僅適用於Android Ora 2.14.25",
  vtUGfp: "公司預設命名規則",
  QgHuyM: "門店命名規則",
  "+Bas2b": "長度: {duration}",
  "+a6DnG": "審核中",
  "/CFd+q": "開",
  "0JQoTX": "審核失敗",
  "0Ru5zG": "尺寸: {size}",
  "0UhE3z": "播放狀態",
  "0btyN9": "長度:",
  "1/U2kj": "影片",
  "1qoi3T": "圖片",
  "3HqLlX": "新增內容",
  "4jU7ke": "啟動內容播放器",
  "4nG/GN": "內容名稱",
  "5RR9aM": "批量暫停",
  "5XSNyG": "上傳素材成功",
  "6K/a0B": "暫停",
  "6wAcmz": "請選擇時間",
  "7M1nFY": "是否確認刪除範本{name}）",
  "7OW60G": "清選擇時間",
  "7Ouq4k": "順序: {sort}",
  "7cAtfM": "次",
  "7wofGo": "應用",
  "9c8SPP": "尺寸",
  BhWZJo: "資源名稱",
  C55Kjj: "播放內容",
  "D+32Ow": "資源管理中心",
  EBMdAL: "創造成功",
  ECm6hH: "是否確認刪除（{name}）該資源？",
  "ELFG/t": "搜尋設備",
  IP9Kbk: "圖片最大不能超過15MB",
  Ie9WHB: "上傳素材",
  KOVFgK: "待審核",
  "Lqca+c": "Player切換",
  MDACCo: "播放成功",
  MWJG8I: "名稱: {name}",
  "Ut8+i2": "審核通過",
  "Xi/+KE": "新增時段",
  YuZxve: "選擇內容",
  bKLb1C: "播放",
  bYujGa: "建立範本",
  fFaC3Z: "播放時段",
  gVXoXc: "內容管理",
  i9lOCU: "您選擇的開始日期早於今天",
  iHQiQV: "大量播放",
  iJIOBp: "解析失敗",
  "iRR+fJ": "debugInfo",
  l9XE8F: "透過",
  lchpP8: "應用成功",
  m8CFrl: "新建範本",
  nbp4U6: "內容模板清單",
  oUgWVb: "類型: {type}",
  "p/EHrl": "影片最大不能超過10GB",
  qx5UwR: "請選擇一個裝置",
  rBWtYz: "最新更改時間",
  rnpMD3: "關",
  sux9FA: "輸入下限：1",
  tRm3bw: "暫停成功",
  uhTa0i: "預覽",
  w1cMGO: "結束日期",
  ztKQno: "長度",
  J3dxzb:
    "Nubis 目前支援 JPEG 和 PNG 影像格式。視訊必須使用 H.264 編解碼器進行編碼。支援的檔案格式包括 MPEG-4 和 MOV。編解碼器是一種軟體或硬件，用於壓縮資料以加快傳輸速度，並將接收到的資料解壓縮回其原始格式。H.264格式。H.264格式。H.264格式。H.264格式。H.264格式。H.264格式。H.264格式。H.264格式。H.264格式。H.264格式。H.264格式。H.264。編解碼器通常用於視訊內容的錄製、壓縮和分發。",
  "M5Vtr/": "編輯模版",
  b1xi4S: "預覽範本",
  kNhfaL: "是否確認刪除範本({name}）",
  kqgd4D: "至少新增一個執行時間",
  "36pf2y": "內容歷史",
  "3izvEF": "選擇檔案",
  "9mG+jv": "檔案大小超過可用空間",
  AlFkwq: "已安裝設備數量",
  C8ZuKU: "圖片寬度",
  E0Czos: "圖片高度",
  I73XLQ: "圖片縱座標",
  JbroVc: "Nubis Cast",
  MMqJtu: "必須選擇一個圖片或影片",
  "Pv/1oy": "內容展示",
  Rrwy85: "創作者",
  T8Y38H: "圖片檔（*.jpg/*.png）",
  VJ7wHx: "待安裝設備數量",
  WI3Hl5: "視訊橫座標",
  "Y2Wh/g": "影片檔（*.mp4/*.mov）",
  "YLvNj+": "待部署",
  kUbrNT: "請先上傳檔案至資源管理中心。範本只能使用審核通過的檔案。",
  n997QX: "影片高度",
  rBD8kj: "圖片橫座標",
  uCmncQ: "視訊寬度",
  QwmhEP: "內容歷史記錄",
  "8vC+0s": "必須選擇一個播放內容",
  "jG/AFY": "確認後裝置將會套用新的設定,且一天內無法再變更設定,確定要套用嗎?",
  "AxZAkZ": "本平台上傳的數字內容將經由 Amazon Rekognition內容審核 自動審查，以降低公開發布的風險。若自動審查未通過，您可選擇手動審核通過；但在此情況下，本平台將不對任何後續影響承擔責任。",
  "Oyd/7c": "手動批准",
  "wyHcKZ": "批准提醒",
  "32HMy/": "{nubis} Cast版本",
  "IS73A4": "起始時間不能大於結束時間",
  "jCAPQ2": "{nubis} Cast模式",
  "sWmzFs": "{ora}最後更新時間",
  "sctjLN": "{ora}最後上線時間",
  "uoBkfP": "{ora}最後更新狀態",
  "3yichR": "最後修改時間",
  "d+otpZ": "發佈版本",
  "k30s+D": "最後發佈時間",
  "9bgunT": "關閉後，您可自行下載新版{ora}安裝，或是透過裝置指令-{ora}更新進行手動更新。",
  "Yh8vRi": "開啟後，若{ora}有新版本時將自動下載與更新。",
  "ZO2gEn": "{nubis}版本",
  "r+yR7v": "{nubis} Cast",
  "uf58G7": "關閉自動更新後，裝置上{ora}版本差異可能會導致部分功能無法使用",
  "y98D3X": "視訊縱座標"
};
